import { HttpClient } from '@angular/common/http';
import { afterNextRender, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, Renderer2, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { MainService } from '../shared/services/main.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { loadStripe } from '@stripe/stripe-js';
import { environment } from '../../environments/environment';
import { DatepickerInlineCalendarComponent } from '../datepicker-inline-calendar/datepicker-inline-calendar.component';
import { map, startWith, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatIconModule } from '@angular/material/icon';

declare var google: any;

@Component({
  selector: 'app-booking-widget',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatRadioModule,
    MatCheckboxModule,
    CommonModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    DatepickerInlineCalendarComponent,
    ScrollingModule,
    MatIconModule,
  ],
  templateUrl: './booking-widget.component.html',
  styleUrl: './booking-widget.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom
})
export class BookingWidgetComponent {
  @Input() external_channel: any;// variable venntur / tour2b
  @Input() api_url: any; // variable https://api.actividadesencanfranc.hub2b.travel
  @Input() channelactivitycode: any; // Variable ID PRODUCTO EN TOUR2B: 42
  @Input() productid: any; // Variable ID PRODUCTO EN B2C: 30
  @Input() isOpenDate: any; // Variable for musment activities (temporal finjo demencia)
  @Input() producttype: any; // Variable Activity
  @Input() web_city: any; // Variable Can Franc
  @Input() PUBLIC_KEY: any; // Variable: pk_test_cycICGEq4Nfma9OeiFOB2rmU00Lapr8BSK / pk_live_z31RtXGJKEPg0Q4EWzIBZfYr00pHmRWYkO
  @Input() lang: any; // Variable: es / en
  @Input() seller: any; // Variable: es / en
  @Input() connector: any; // Variable: es / en
  @Input() success_url: any;
  @Input() error_url: any;
  // @Input() WEB_TITLE: any; Variable 'Actividades En Can Franc'

  @Input() price: any;
  @Input() isCredit: any;
  @Input() isOnRequest: any;
  @Input() isActive: any;
  @Input() productTitle: any;
  @Input() daysToPayBeforeStay: any;
  @Input() release: any;
  @Input() queryParams: any;
  @Input() dateParams: any;

  @Output() sentData: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('visibility') visibility: any;
  @ViewChild('addresstext') addresstext: any;

  currentStep: any = 0;
  currentRoute: string = '';
  mainLanguages = ['es', 'en', 'de'];
  language: string = 'es'; // Por defecto, el idioma es español
  startDate = new Date();
  bookingForm!: FormGroup;
  externalPaxDetailsForm!: FormGroup;
  isCalendarOpen = true;
  showPaymentForm = false;
  configuration: any;
  selectedModality: any;
  clientsRequested = 0;

  showHourSelection: boolean = false;
  // Availability
  productIsOnRequest: any;
  availableSchedules = <any>[];
  modalities: any = {};
  isOnTransferTime: any;
  isOnRelease: any;
  bookingDates: any;
  room: any = {
    adults: 2,
    kids: 0,
    babies: 0,
  };
  booking: any = { clientTypes: {} };
  showPaymentMethodForm: any;
  roomArray = [this.room];
  totalPriceCost: any = 0;
  totalPVD: number = 0;
  totalPartnerCommission: number = 0;
  isPrebookingRequested = false;
  incompleteAlert: any;
  paxResume: any;
  countries: any;
  filteredCountries!: Observable<any[]>;

  stripe: any;
  stripePromise: Promise<any> = Promise.resolve();
  elements: any;

  pickupScheduleInRadious: any;
  closestPickupSchedule: any;
  closestDistance = Infinity;
  selectedLatitude: any = null
  selectedLongitude: any = null
  bookingId: any;
  error: any;
  selectedIndex: number = -1;
  selectedScheduleIndex: number = -1;
  resumeModality: string = '';
  isCalendarDisabled = false;
  moreText = false;
  // Flag set when child datepicker reports no pickup availability
  isPickupNoAvailability: boolean = false;
  calendarNoAvailability: boolean = false;
  // Message to show when the closest pickup is outside configured radius
  pickupDistanceTime: string = "";
  closestPickupMessage: string | null = null;
  formattedClients = <any>[];
  isLoading = true;
  pickups: any;
  dynamic_form: any;

  isTooltipVisible = false;
  tooltipPosition = { x: 0, y: 0 };
  shadowRoot: any;

  totalClientTypesSelected: number = 0;
  // WEB_TITLE = 'Actividades En Can Franc'; variable
  // WEB_CITY = 'Can Franc'; variable
  paymentMethod: any;
  dynamicQuestions = <any>[];

  loadDayAvailability = false;
  loadRealAvailability = false;
  loadPrebook = false;
  errorPrebook = false;
  modHasRealAvailability = true;
  // dynamicQuestionsArray!: FormArray;

  isValidSeller = false;
  showInvalidSellerError = false;
  validActivity = false;
  validSeller = false;
  formattedActivityPrices = <any>[];
  pricing: any = {};
  partner: any;
  clientTypeList: string[] = [];
  paxControlList: any;

  dynamicApiUrl: any;
  tieneCamposAll: boolean = false;
  paxRules: any = {};
  loadingPaxDetails = false;

  refreshTick = 0; //refresh calendar if pickup changes
  showCountryCodes = false;
  countriesToShow: any;

  isStepTwoCollapsed = false;
  selectedRangeValue: any;

  constructor(private renderer: Renderer2, private router: Router, private fb: FormBuilder, public mainService: MainService, private http: HttpClient, public translateService: TranslateService, private elementRef: ElementRef, private cdr: ChangeDetectorRef) {
    this.injectBootstrap();
    afterNextRender(() => {
      setTimeout(() => {
        this.dynamicApiUrl = this.connector != 'hub2b' ? this.api_url : 'https://api.' + this.external_channel + environment.hub2bEnv
        this.translateService.setDefaultLang(this.lang);
        this.translateService.use(this.lang);
        if (!this.partner) {
          if (this.seller) {
            this.mainService.getByParameter(this.api_url, 'sellers.id', this.seller, 'partners', this.lang).subscribe(partner => {
              partner = partner['hydra:member'][0];
              this.pricing = partner.pricing;
              this.partner = partner;
              this.checkWidget();
              this.mainService.getByParameter(this.api_url, 'partner.id', partner.id, 'configurations', this.lang).subscribe(resp => {
                if (resp['hydra:member'].length > 0) {
                  resp = resp['hydra:member'][0];
                  this.configuration = resp;
                  localStorage.setItem('configuration', JSON.stringify(resp));
                  this.setColors(resp.mainColor, resp.secondaryColor);
                } else {
                  this.mainService.getFirst(this.api_url, 'configurations', this.lang).subscribe(resp => {
                    resp = resp['hydra:member'][0];
                    this.configuration = resp;
                    localStorage.setItem('configuration', JSON.stringify(resp));
                    this.setColors(resp.mainColor, resp.secondaryColor);
                    this.checkWidget();
                  })
                }

              })
            })
          } else {
            let partnerSlug = this.api_url.split('.')[1];
            this.mainService.getByParameter(this.dynamicApiUrl, 'slug', partnerSlug, 'partners', this.lang).subscribe(partner => {
              partner = partner['hydra:member'][0];
              this.pricing = partner.pricing;
              this.partner = partner;
              this.seller = partner.sellers[0].id;
            })
            this.mainService.getFirst(this.api_url, 'configurations', this.lang).subscribe(resp => {
              resp = resp['hydra:member'][0];
              this.configuration = resp;
              localStorage.setItem('configuration', JSON.stringify(resp));
              this.setColors(resp.mainColor, resp.secondaryColor);
              this.checkWidget();
            })
          }
        }
      }, 1000);
    })
  };

  ngOnChanges() {
    if (!this.isOnRequest) {
      if (this.PUBLIC_KEY && !this.stripe) {
        this.stripePromise = loadStripe(this.PUBLIC_KEY);
        // Load Stripe for widget
        this.stripePromise.then(stripe => {
          this.stripe = stripe;
          if (this.stripe) {
            console.log('Stripe cargado correctamente');
          } else {
            console.error('Error al cargar Stripe');
          }
        });
      } else {
        console.warn('Por favor, introduzca una clave pública de Stripe.')
      }
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (["musement_pull", "lowcosttours_pull"].includes(this.external_channel)) {
        if (this.isOpenDate) {
          this.mainService.getConnection(this.connector, this.external_channel, 'availabilities', { 'isOpenDate': true }, this.lang, this.channelactivitycode).subscribe(results => {
            let res_modalities = results
            this.bookingDates = { start: new Date(results[0].date), end: new Date(results[0].date) };
            this.currentStep = 2;

            res_modalities.forEach((result: any) => {
              if (result.activitySchedule) {
                if (this.modalities[result.activitySchedule.activitySeason.activityFee.modality.title]) {
                  this.modalities[result.activitySchedule.activitySeason.activityFee.modality.title].push(result);
                } else {
                  this.modalities[result.activitySchedule.activitySeason.activityFee.modality.title] = [result];
                }
                if (result.activitySchedule.activitySeason.isOnRequest || result.activitySchedule.activitySeason.activityFee.activity.isOnRequest) {
                  this.isOnRequest = true;
                }
              }
            });

            // // Rehabilitar el calendario después de completar todas las solicitudes
            // this.isCalendarDisabled = false;

            // Ejecutar el bloque final después de procesar todas las modalidades
            Object.keys(this.modalities).forEach((modality: any) => {
              this.setAvailableSchedules(modality);
            });

          })
        } else {
          this.mainService.getConnection(this.connector, this.external_channel, 'pickups', {}, this.lang, this.channelactivitycode).subscribe(resp => {
            let array_pickups = resp.pickups ?? resp
            if (array_pickups.length > 0) {
              this.currentStep = 0;
              this.pickups = array_pickups
              // this.getPlaceAutocomplete()
              setTimeout(() => {
                this.getPlaceAutocomplete()
              }, 1000);
            } else {
              this.currentStep = 1
            }
          })
        }

      } else {
        this.currentStep = 1
      }
    }, 1000);
  }

  ngOnInit() {
    this.bookingForm = this.fb.group({
      name: [null, Validators.required],
      countryCode: ['+34', [
        Validators.required,
        Validators.pattern(/^\+\d{1,4}$/)
      ]],
      phone: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      hotel: [null],
      observations: [null],
      dynamicQuestions: this.fb.array([]),
      conditions: [true, Validators.required],
      newsletter: [false],
      coupon: [null],
      date: [this.startDate],
      pickupSchedule: [],
      ubication: [''],
      sellerCode: [''],
      pax: this.fb.array([])
    })
    // Obtener la ruta actual al inicio y suscribirse a cambios en la ruta
    this.currentRoute = this.router.url;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
      }
    });

    this.http.get<any>(environment.translationUrl + 'assets/json/country_codes.json')
      .subscribe((countries: any[]) => {
        this.countries = countries;
      });

    this.shadowRoot = this.elementRef.nativeElement.shadowRoot;
    this.shadowRoot.addEventListener('pointerdown', (event: PointerEvent) => this.onShadowClick(event));
  }

  get name() { return this.bookingForm.get('name'); }
  get email() { return this.bookingForm.get('email'); }
  get countryCode() { return this.bookingForm.get('countryCode'); }
  get phone() { return this.bookingForm.get('phone'); }
  get message() { return this.bookingForm.get('message'); }
  get privacy() { return this.bookingForm.get('privacy'); }
  get dynamicQuestionsArray(): FormArray {
    return this.bookingForm.get('dynamicQuestions') as FormArray;
  }

  nextStep() {
    setTimeout(() => {
      this.currentStep++;
      // Musement_pull: If we're moving to step 1 after a no-availability reset, clear the flag
      // and force the calendar refresh so the child component re-queries availabilities.
      if (this.currentStep === 1) {
        this.isPickupNoAvailability = false;
        if (this.refreshTick <= 1) {
          this.refreshTick = 2;
        } else {
          this.refreshTick++;
        }
      }
      if (this.currentStep == 2) {
        this.toggleAccordion('collapseOne');
        this.toggleAccordion('collapseTwo');
        this.scrollNextStep('modalitiesAccordion')
      } else if (this.currentStep == 3) {
        this.toggleAccordion('collapseTwo')
        this.scrollNextStep('locationAccordion')
        // Verifica si los elementos están disponibles
        const hasPickup = this.modalities[this.resumeModality][0].activitySchedule.activitySeason.activityFee.modality.hasPickup
        if (!hasPickup) {
          this.currentStep++;
          // this.getClosestZone();
          // this.getPlaceAutocomplete();
          let pickupSchedules;

          if (this.pickups) {
            pickupSchedules = this.pickups;
          } else if (this.booking.availableSchedule.activitySchedule.pickupSchedules && this.booking.availableSchedule.activitySchedule.pickupSchedules.length > 0) {
            pickupSchedules = this.booking.availableSchedule.activitySchedule.pickupSchedules;
          } else {
            pickupSchedules = this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.pickupSchedules;
            if (this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupGroupSchedules?.pickupSchedules && this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupGroupSchedules?.pickupSchedules.length > 0) {
              pickupSchedules = pickupSchedules.concat(this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupGroupSchedules?.pickupSchedules);
            }
          }

          this.selectedLatitude = localStorage.getItem('userLat')
          this.selectedLongitude = localStorage.getItem('userLon')
          if (this.external_channel != "musement_pull") {
            this.getClosestPickupSchedule(pickupSchedules, this.selectedLatitude, this.selectedLongitude)
            this.refreshTick++;
          }
        } else {
          if (this.partner.type == 'hotel') {
            console.log(this.configuration);
            this.selectedLatitude = this.configuration.latitude
            this.selectedLongitude = this.configuration.longitude
            this.bookingForm.controls['ubication'].setValue(this.partner.name)
            // this.getHotelName(this.selectedLatitude, this.selectedLongitude);
            // this.getPlaceAutocomplete();
            this.changeVisibility();
            let pickupSchedules;

            if (this.pickups) {
              pickupSchedules = this.pickups;
            } else if (this.booking.availableSchedule.activitySchedule.pickupSchedules && this.booking.availableSchedule.activitySchedule.pickupSchedules.length > 0) {
              pickupSchedules = this.booking.availableSchedule.activitySchedule.pickupSchedules;
            } else {
              pickupSchedules = this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.pickupSchedules;
              if (this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupGroupSchedules?.pickupSchedules && this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupGroupSchedules?.pickupSchedules.length > 0) {
                pickupSchedules = pickupSchedules.concat(this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupGroupSchedules?.pickupSchedules);
              }
            }
            this.getClosestPickupSchedule(pickupSchedules, this.selectedLatitude, this.selectedLongitude)
            this.refreshTick++;
          } else {
            this.getPlaceAutocomplete();
            this.changeVisibility();
            // Fill the autocomplete value on step 3
            if (localStorage.getItem('userLat') && localStorage.getItem('userLon') && localStorage.getItem('userLoc')) {
              this.bookingForm.get('ubication')?.setValue(localStorage.getItem('userLoc'));
              let pickupSchedules;

              if (this.pickups) {
                pickupSchedules = this.pickups;
              } else if (this.booking.availableSchedule.activitySchedule.pickupSchedules && this.booking.availableSchedule.activitySchedule.pickupSchedules.length > 0) {
                pickupSchedules = this.booking.availableSchedule.activitySchedule.pickupSchedules;
              } else {
                pickupSchedules = this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.pickupSchedules;
                if (this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupGroupSchedules?.pickupSchedules && this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupGroupSchedules?.pickupSchedules.length > 0) {
                  pickupSchedules = pickupSchedules.concat(this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupGroupSchedules?.pickupSchedules);
                }
              }

              this.selectedLatitude = localStorage.getItem('userLat')
              this.selectedLongitude = localStorage.getItem('userLon')
              this.getClosestPickupSchedule(pickupSchedules, this.selectedLatitude, this.selectedLongitude)
            }
          }
        }
        if (this.connector == "geant") {
          // this.getCorrectModality();
          this.getPaxDetails();
        }
        this.getTotalPrice();
      } else if (this.currentStep > 3) {
        this.renderer.setStyle(this.visibility.nativeElement, 'height', 0);
        if (this.currentStep == 4) {
          this.scrollNextStep('step4')
        } else if (this.currentStep == 5 && !this.isOnRequest) {
          this.booking.dynamicQuestions = []
          this.dynamicQuestions.forEach((dynamicQuestion: any, index: number) => {
            if (dynamicQuestion.externalId) {
              this.booking.dynamicQuestions.push(
                {
                  question: dynamicQuestion.title,
                  answer: this.bookingForm.get('dynamicQuestions')?.value[index],
                  id: dynamicQuestion.externalId,
                  context: dynamicQuestion.externalContext,
                }
              )
            } else {
              this.booking.dynamicQuestions.push(
                {
                  question: dynamicQuestion.title,
                  answer: this.bookingForm.get('dynamicQuestions')?.value[index]
                }
              )
            }
          });
          if (!this.configuration.paymentTypes || (this.configuration.paymentTypes && !this.configuration.paymentTypes.includes('cash') && !this.configuration.paymentTypes.includes('credit'))) {
            this.preBooking()
          }
          this.scrollNextStep('step5')
        }
      }
    }, 250);
  }

  scrollNextStep(elementId: string): void {
    setTimeout(() => {
      this.shadowRoot = this.elementRef.nativeElement.shadowRoot;
      const element = this.shadowRoot.querySelector('#' + elementId)
      if (element) {
        // element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        console.warn(`Element with ID "${elementId}" not found.`);
      }
    }, 100);
  }

  changeVisibility() {
    const hasPickup = this.modalities[this.resumeModality][0].activitySchedule.activitySeason.activityFee.modality.hasPickup;
    if (this.visibility && hasPickup) {
      // Mover el elemento y quitar el atributo 'hidden'
      this.renderer.setStyle(this.visibility.nativeElement, 'height', 'auto');
    } else if (!hasPickup) {
      this.currentStep++;
    }
  }

  prevStep() {
    setTimeout(() => {
      this.currentStep--;
    }, 250);
  }

  receiveSelectedAvailabilities(event: any) {
    this.loadDayAvailability = true
    this.selectedIndex = -1;
    this.activityLogic(event);
    this.sendhideCtaData();
  }

  // Handler for child datepicker no-availability signal (musment)
  // Handle no availability on calendar (hub2b)
  async onNoPickupAvailable(event: any) {
    // event may be a boolean (legacy) or an object { noAvailability: boolean, pickup?: any }
    const noAvailability = typeof event === 'boolean' ? event : event?.noAvailability;

    if (this.external_channel != "musement_pull") {
      this.isPickupNoAvailability = false
      if (noAvailability) {
        // this.isCalendarDisabled = false;
        this.calendarNoAvailability = true;
        return
      } else {
        this.calendarNoAvailability = false;
        return
      }
    }


    if (noAvailability) {
      // Volver al primer paso para ocultar la sección de fecha y permitir reiniciar
      if (this.pickups && event?.invalid_pickup) {
        this.isPickupNoAvailability = !!noAvailability;
        this.currentStep = 0;
        this.pickupScheduleInRadious = null;
        this.closestPickupSchedule = null;
        this.selectedRangeValue = undefined;
      }
      // Limpiar selección de fechas y estado del calendario
      this.bookingDates = null;
      this.selectedIndex = -1;
      this.availableSchedules = [];
      this.isCalendarDisabled = false;
      this.closestPickupMessage = null;
    } else {
      // Disponibilidad encontrada: if pickup provided, update selection and show distance message when appropriate
      const pickup = event && event.pickup ? event.pickup : null;

      console.log(pickup)

      if (pickup) {
        // Reuse existing logic to set booking pickup and related fields
        // this.updatePickupSelected(pickup);

        // If we have user coords, compute distance and show message when > 2 km
        if (this.selectedLatitude && this.selectedLongitude) {
          const userLat = parseFloat(String(this.selectedLatitude));
          const userLon = parseFloat(String(this.selectedLongitude));
          const pickupLat = pickup?.latitude ?? pickup?.pickupLatitude ?? pickup?.pickup?.latitude ?? null;
          const pickupLon = pickup?.longitude ?? pickup?.pickupLongitude ?? pickup?.pickup?.longitude ?? null;
          const pickupLatNum = pickupLat !== null ? parseFloat(String(pickupLat)) : NaN;
          const pickupLonNum = pickupLon !== null ? parseFloat(String(pickupLon)) : NaN;
          if (!isNaN(pickupLatNum) && !isNaN(pickupLonNum)) {
            const d = await this.getDistanceMatrix(userLat, userLon, pickupLatNum, pickupLonNum);
            if (d > 2) {
              const address = (pickup && (pickup.address || pickup.pickupAddress || pickup.pickup?.address || pickup.title || pickup.pickup?.title)) || '';
              this.closestPickupMessage = this.translateService.instant(
                'product.closestPickupDistance',
                {
                  distance: `<strong>${d.toFixed(2)}</strong>`,
                  address: `<strong>${address}</strong>`
                }
              );
            } else {
              this.closestPickupMessage = null;
            }
          }
        }
      }
    }
  }

  setPickupSchedule(event: any) {
    let pickupSchedule = this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.pickupSchedules.filter((pickupSchedule: any) => {
      return pickupSchedule.pickup['id'] == event.target.value;
    })

    this.booking.pickup = { 'startTime': pickupSchedule[0].startTime, 'title': pickupSchedule[0].pickup.title, 'description': pickupSchedule[0].pickup.description, 'address': pickupSchedule[0].pickup.address, 'maps': this.returnMapsCoordenates(pickupSchedule), 'imageUrl': pickupSchedule[0].pickup.imageUrl, 'hasPickup': this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.hasPickup };
  }

  activityLogic(event: any) {
    this.isCalendarDisabled = true;

    if (this.productIsOnRequest === undefined) {
      this.productIsOnRequest = this.isOnRequest;
    }
    this.isOnRequest = this.productIsOnRequest;
    this.availableSchedules = [];
    const currentRooms: any = [];

    const startDay = new Date(event.selectedValue.start).toLocaleDateString("en-US", { timeZone: 'Europe/Madrid' });
    const endDay = new Date(event.selectedValue.end).toLocaleDateString("en-US", { timeZone: 'Europe/Madrid' });

    this.isOnTransferTime = new Date(new Date().setDate(new Date().getDate() + this.daysToPayBeforeStay)).setHours(0, 0, 0, 0) <= new Date(event.selectedValue.start).getTime();

    this.bookingDates = { start: new Date(event.selectedValue.start), end: new Date(event.selectedValue.end) };

    const currentDayAvailabilities = event.availableDays.filter((element: any) =>
      new Date(element.date ? element.date : element).toLocaleDateString("en-US", { timeZone: 'Europe/Madrid' }) >= startDay &&
      new Date(element.date ? element.date : element).toLocaleDateString("en-US", { timeZone: 'Europe/Madrid' }) <= endDay
    );

    this.modalities = {};

    // Crear un array de observables para las llamadas a getConnection

    const observables = currentDayAvailabilities.map((currentDay: any) =>
      this.mainService.getConnection(this.connector, this.external_channel, 'activity_availabilities', currentDay.id ? currentDay.id : currentDay, this.translateService.currentLang, this.channelactivitycode)
    );

    // Usar forkJoin para esperar a que todas las llamadas se completen
    forkJoin(observables).subscribe((results: any) => {
      let res_modalities = results
      let res_pickups = null

      if (results && Array.isArray(results) && results[0].modalities) {
        res_modalities = results[0].modalities
        if (results[0].pickups) {
          res_pickups = results[0].pickups
        }
      } else if (this.connector != 'hub2b') {
        res_modalities = results[0]
      }

      res_modalities.forEach((result: any) => {
        if (!result.activitySchedule) {
          return;
        }
        // Check de ubicación de usuario dentro de perímetro
        if (!this.shouldShowModality(result)) {
          console.log('Modalidad oculta por ubicación del usuario fuera de perímetro:', result.activitySchedule.activitySeason.activityFee.modality.title);
          return;
        }

        const title = result.activitySchedule.activitySeason.activityFee.modality.title;

        if (this.modalities[title]) {
          this.modalities[title].push(result);
        } else {
          this.modalities[title] = [result];
        }

        if (result.activitySchedule.activitySeason.isOnRequest) {
          this.isOnRequest = true;
        }
      });

      if (res_pickups) {
        this.pickups = results[0].pickups;
      }

      // Rehabilitar el calendario después de completar todas las solicitudes
      this.isCalendarDisabled = false;

      // Ejecutar el bloque final después de procesar todas las modalidades
      Object.keys(this.modalities).forEach((modality: any) => {
        this.setAvailableSchedules(modality);
      });

      this.loadDayAvailability = false
    });
  }

  getModalities() {
    return Object.keys(this.modalities);
  }

  shouldShowModality(result: any): boolean {
    const latStr = localStorage.getItem('userLat');
    const lonStr = localStorage.getItem('userLon');

    const userLat = latStr !== null ? Number(latStr) : null;
    const userLon = lonStr !== null ? Number(lonStr) : null;

    const hasUserLocation =
      userLat !== null &&
      userLon !== null &&
      !isNaN(userLat) &&
      !isNaN(userLon);

    // Si el usuario no ha compartido ubicación -> mostrar siempre
    if (!hasUserLocation) {
      // console.log('Usuario sin ubicación, mostrando modalidad por defecto:', result.activitySchedule.activitySeason.activityFee.modality.title);
      return true;
    }

    // Ajustar esta ruta a donde tengamos realmente las recogidas
    const pickupSchedules =
      result?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupSchedules ?? [];

    // Si no tiene recogidas -> mostrar
    if (!Array.isArray(pickupSchedules) || pickupSchedules.length === 0) {
      // console.log('Modalidad sin recogidas, mostrando por defecto:', result.activitySchedule.activitySeason.activityFee.modality.title);
      return true;
    }

    let hasPerimeterPickup = false;
    let hasPickupWithoutPerimeter = false;
    let userInsideAnyPerimeter = false;

    for (const pickupSchedule of pickupSchedules) {
      const pickup = pickupSchedule?.pickup;
      const perimeterArea = pickup?.zone?.perimeterArea;

      if (perimeterArea) {
        hasPerimeterPickup = true;

        const isInside = this.isPointInsidePerimeter(
          { lat: userLat, lon: userLon },
          perimeterArea
        );

        if (isInside) {
          userInsideAnyPerimeter = true;
          break;
        }
      } else {
        hasPickupWithoutPerimeter = true;
      }
    }

    // Si tiene una o más recogidas con perímetro
    if (hasPerimeterPickup) {
      // Usuario dentro de algún perímetro -> mostrar
      if (userInsideAnyPerimeter) {
        // console.log('Usuario dentro de perímetro, mostrando modalidad:', result.activitySchedule.activitySeason.activityFee.modality.title);
        return true;
      }

      // Usuario fuera de todos los perímetros,
      // pero hay recogidas sin perímetro -> mostrar
      if (hasPickupWithoutPerimeter) {
        // console.log('Usuario fuera de perímetros, pero hay recogidas sin perímetro. Mostrando modalidad:', result.activitySchedule.activitySeason.activityFee.modality.title);
        return true;
      }

      // Usuario fuera de todos los perímetros
      // y no hay recogidas sin perímetro -> no mostrar
      // console.log('Usuario fuera de perímetros y no hay recogidas sin perímetro. Ocultando modalidad:', result.activitySchedule.activitySeason.activityFee.modality.title);
      return false;
    }

    // Si no tiene perímetro en ninguna recogida -> mostrar
    // console.log('No hay perímetros en las recogidas, mostrando modalidad por defecto:', result.activitySchedule.activitySeason.activityFee.modality.title);
    return true;
  }

  isPointInsidePerimeter(
    user: { lat: number; lon: number },
    perimeterArea: any
  ): boolean {

    if (!perimeterArea) return false;

    // Si viene como string JSON
    const parsed = typeof perimeterArea === 'string'
      ? JSON.parse(perimeterArea)
      : perimeterArea;

    if (!Array.isArray(parsed)) return false;

    const polygon = new google.maps.Polygon({
      paths: parsed.map((p: any) => ({
        lat: Number(p.lat),
        lng: Number(p.lng),
      })),
    });

    const point = new google.maps.LatLng(user.lat, user.lon);

    return google.maps.geometry.poly.containsLocation(point, polygon);
  }

  setAvailableSchedules(modality: any) {
    let value;
    if (modality.target) {
      value = modality.target.value
    } else {
      value = modality
    }

    this.availableSchedules[value] = this.modalities[value];

    // If there is only one modality and modality shedule available:
    if (Object.keys(this.modalities).length === 1 && this.availableSchedules[Object.keys(this.modalities)[0]].length === 1 && !this.checkReleaseOnSchedule(this.availableSchedules[Object.keys(this.modalities)[0]][0])) {
      this.resumeModality = Object.keys(this.modalities)[0];
      this.selectedIndex = 0;
      this.selectedScheduleIndex = 0;
      this.booking.availableSchedule = this.availableSchedules[Object.keys(this.modalities)[0]][0];
      this.room.schedule = null;
      this.formattedActivityPrices = this.getUniqueClientTypesByTitle(this.booking.availableSchedule.activitySchedule.activityPrices);

      this.selectedModality = {
        title: modality,
        description: this.modalities[this.resumeModality][0].activitySchedule.activitySeason.activityFee.modality.description,
        dynamicQuestions: this.modalities[this.resumeModality][0].activitySchedule.activitySeason.activityFee.modality.dynamicQuestions,
        pickupHelpText: this.modalities[this.resumeModality][0].activitySchedule.activitySeason.activityFee.modality.pickupHelpText
      };
      // console.log(this.selectedModality);

      this.dynamicQuestionsArray.clear();
      // console.log(this.dynamicQuestionsArray);


      if (this.selectedModality.dynamicQuestions) {
        this.selectedModality.dynamicQuestions.forEach((dynamicQuestion: any) => {
          this.dynamicQuestions = [];

          let id = dynamicQuestion.split('/')[2];
          if (this.api_url.split('.')[1] == this.external_channel) {
            // API_URL: string, id: any, endpoint: string, language: any            
            this.mainService.get(this.dynamicApiUrl, id, 'dynamic_questions', this.lang).subscribe(resp => {
              this.dynamicQuestions.push(resp)
              if (resp.isMandatory) {
                this.dynamicQuestionsArray.push(new FormControl('', Validators.required));
              } else {
                this.dynamicQuestionsArray.push(new FormControl(''));
              }
            })
          } else {
            // externalChannel: string, endpoint: string, id: string, language: any
            this.mainService.getConnection(this.connector, this.external_channel, 'dynamic_questions', id, this.lang).subscribe(resp => {
              this.dynamicQuestions.push(resp)
              if (resp.isMandatory) {
                this.dynamicQuestionsArray.push(new FormControl('', Validators.required));
              } else {
                this.dynamicQuestionsArray.push(new FormControl(''));
              }
            })
          }
        })
      }

      this.setHorary(this.availableSchedules[Object.keys(this.modalities)[0]][0].activitySchedule.startTime);

      // Convertir los objetos en arrays usando Object.values()
      let together;
      if (this.booking.availableSchedule?.activitySchedule.pickupSchedules && this.booking.availableSchedule?.activitySchedule.pickupSchedules.length > 0) {
        together = Object.values(this.booking.availableSchedule?.activitySchedule?.pickupSchedules || {});
      } else {
        const pickupSchedulesArray1 = Object.values(this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupGroupSchedules?.pickupSchedules || {});
        const pickupSchedulesArray2 = Object.values(this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupSchedules || {});
        together = pickupSchedulesArray1.concat(pickupSchedulesArray2) as any;
      }

      const uniqueObjects = new Map<string, any>();

      for (const obj of together) {
        uniqueObjects.set(obj["@id"], obj); // Si existe, lo reemplaza; si no, lo agrega
      }

      if (together && together.length > 0) {
        // this.getClosestPickupSchedule(this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.pickupSchedules)
        this.getClosestPickupSchedule(Array.from(uniqueObjects.values()))
      }

      // Al final del loop, fuera del for
      setTimeout(() => {
        this.dynamicQuestions = this.dynamicQuestions.filter(
          (question: any, index: any, self: any) =>
            index === self.findIndex((q: any) => q.id === question.id)
        );
      }, 1000);
    }
  }

  setHorary(horary: any) {
    let startCopy = new Date(this.bookingDates.start);
    let [addHours, addMinutes] = horary.split(':').map(Number);
    startCopy.setHours(startCopy.getHours() + addHours);
    startCopy.setMinutes(startCopy.getMinutes() + addMinutes);
    this.showHourSelection = true;
    this.booking.availableSchedule.activitySchedule.activityPrices = this.booking.availableSchedule.activitySchedule.activityPrices.sort((a: any, b: any) => { return a.price < b.price })
    this.booking.clientTypes = {};
  }

  changeExternalLanguage(event: any) {
    this.booking.externalLanguage = event.target.value;
  }

  changeTotalQuantity(clientType: any, clientTypeCode: any, event: any, clientTypeObj: any) {

    let quantity = event.target.value;
    if (this.booking.clientTypes[clientTypeCode]) {
      this.booking.clientTypes[clientTypeCode].quantity = quantity;
    } else {
      this.booking.clientTypes[clientTypeCode] = {};
      this.booking.clientTypes[clientTypeCode].quantity = quantity;
      this.booking.clientTypes[clientTypeCode].title = clientType;
      this.booking.clientTypes[clientTypeCode].externalCode = clientTypeObj.id;
      this.booking.clientTypes[clientTypeCode].type = clientTypeObj.clientType ? clientTypeObj.clientType.type : '';
    }
    this.totalClientTypesSelected = this.totalClientTypesSelected + parseInt(quantity);
    this.clientTypeQuantity();
  }

  clientTypeQuantity() {
    const bookingLineDataClientTypes = this.booking.clientTypes
    let clientTypeString = "";
    let i = 0;
    Object.keys(bookingLineDataClientTypes).forEach((clientTypeKey: any) => {
      const clientType = bookingLineDataClientTypes[clientTypeKey]
      if (clientType.quantity > 0) {
        clientTypeString += (i > 0 ? ', ' : '') + clientType.quantity + ' ' + clientType.title
      }
      i++;
    })

    this.paxResume = clientTypeString;
  }

  getTotalPrice() {
    let totalPrice = 0;
    this.totalPriceCost = 0;
    this.totalPVD = 0;
    this.totalPartnerCommission = 0;

    if (this.booking.availableSchedule) {
      if (this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.priceType == 'tiered') {
        // TO DO: Lógica de precios escalonados:
        // Al seleccionar numero de clientes, si es un precio escalonado, 
        // buscar la cantidad seleccionada dentro del rango de precios
        // y al dar a siguiente, enviar los precios actualizados

        // console.log(this.booking.clientTypes);
        // console.log(this.booking.availableSchedule.activitySchedule.activityPrices);
        Object.entries(this.booking.clientTypes).forEach(([key, value]: [string, any]) => {
          this.booking.availableSchedule.activitySchedule.activityPrices.forEach((activityPrice: any) => {
            if (value.title == activityPrice.clientType.title && parseInt(value.quantity) >= activityPrice.rangeFrom && parseInt(value.quantity) <= activityPrice.rangeTo) {
              this.booking.clientTypes[activityPrice.clientType.code].price = this.rounded(this.booking.clientTypes[activityPrice.clientType.code].quantity * (this.pricing.markup ? ((activityPrice.cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) >= activityPrice.price ? (activityPrice.cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) : activityPrice.price) : activityPrice.price));
              this.booking.clientTypes[activityPrice.clientType.code].priceCost = this.booking.clientTypes[activityPrice.clientType.code].quantity * activityPrice.cost;
              this.booking.clientTypes[activityPrice.clientType.code].pvd = this.calculatePVD(activityPrice.price, this.booking.clientTypes[activityPrice.clientType.code].quantity, activityPrice.cost);
              this.booking.clientTypes[activityPrice.clientType.code].profit = this.rounded(this.booking.clientTypes[activityPrice.clientType.code].price - this.booking.clientTypes[activityPrice.clientType.code].priceCost);
              this.booking.clientTypes[activityPrice.clientType.code].clientType = activityPrice.clientType.title;
              totalPrice += this.booking.clientTypes[activityPrice.clientType.code].price;
              this.totalPriceCost += this.booking.clientTypes[activityPrice.clientType.code].quantity * activityPrice.cost;
              this.totalPVD += this.booking.clientTypes[activityPrice.clientType.code].pvd;
            }
          });
        });
      } else if (this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.priceType == 'mixed') {
        // Añadir precio mixto a la reserva en el caso de que el precio de la misma sea mixto
        this.booking.clientTypes['mixed'] = {};
        this.booking.clientTypes['mixed'].quantity = 1;
        this.booking.clientTypes['mixed'].title = this.translateService.instant('product.service');
        this.booking.clientTypes['mixed'].price = this.rounded(1 * (this.pricing.markup ? ((this.booking.availableSchedule.activitySchedule.baseCost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) >= parseFloat(this.booking.availableSchedule.activitySchedule.basePrice) ? (this.booking.availableSchedule.activitySchedule.baseCost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) : parseFloat(this.booking.availableSchedule.activitySchedule.basePrice)) : parseFloat(this.booking.availableSchedule.activitySchedule.basePrice)))
        this.booking.clientTypes['mixed'].priceCost = parseFloat(this.booking.availableSchedule.activitySchedule.baseCost);
        this.booking.clientTypes['mixed'].pvd = this.calculatePVD(this.booking.availableSchedule.activitySchedule.basePrice, 1, this.booking.availableSchedule.activitySchedule.baseCost);
        this.booking.clientTypes['mixed'].profit = this.rounded(this.booking.clientTypes['mixed'].price - this.booking.availableSchedule.activitySchedule.baseCost);
        this.booking.clientTypes['mixed'].clientType = this.translateService.instant('product.service');
        totalPrice += this.booking.clientTypes['mixed'].price;
        this.totalPriceCost += parseFloat(this.booking.availableSchedule.activitySchedule.baseCost);
        this.totalPVD += this.booking.clientTypes['mixed'].pvd;

        this.booking.availableSchedule.activitySchedule.activityPrices.forEach((activityPrice: any) => {
          if (this.booking.clientTypes[activityPrice.clientType.code]) {
            this.booking.clientTypes[activityPrice.clientType.code].price = this.rounded(this.booking.clientTypes[activityPrice.clientType.code].quantity * (this.pricing.markup ? ((activityPrice.cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) >= activityPrice.price ? (activityPrice.cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) : activityPrice.price) : activityPrice.price));
            this.booking.clientTypes[activityPrice.clientType.code].priceCost = this.booking.clientTypes[activityPrice.clientType.code].quantity * activityPrice.cost;
            this.booking.clientTypes[activityPrice.clientType.code].pvd = this.calculatePVD(activityPrice.price, this.booking.clientTypes[activityPrice.clientType.code].quantity, activityPrice.cost);
            this.booking.clientTypes[activityPrice.clientType.code].profit = this.rounded(this.booking.clientTypes[activityPrice.clientType.code].price - this.booking.clientTypes[activityPrice.clientType.code].priceCost);
            this.booking.clientTypes[activityPrice.clientType.code].clientType = activityPrice.clientType.title;
            totalPrice += this.booking.clientTypes[activityPrice.clientType.code].price;
            this.totalPriceCost += this.booking.clientTypes[activityPrice.clientType.code].quantity * activityPrice.cost;
            this.totalPVD += this.booking.clientTypes[activityPrice.clientType.code].pvd;
          }
        })
      } else {
        this.booking.availableSchedule.activitySchedule.activityPrices.forEach((activityPrice: any) => {
          if (this.booking.clientTypes[activityPrice.clientType.code]) {
            this.booking.clientTypes[activityPrice.clientType.code].price = this.rounded(this.booking.clientTypes[activityPrice.clientType.code].quantity * (this.pricing.markup ? ((activityPrice.cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) >= activityPrice.price ? (activityPrice.cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) : activityPrice.price) : activityPrice.price));
            this.booking.clientTypes[activityPrice.clientType.code].priceCost = this.booking.clientTypes[activityPrice.clientType.code].quantity * activityPrice.cost;
            this.booking.clientTypes[activityPrice.clientType.code].pvd = this.calculatePVD(activityPrice.price, this.booking.clientTypes[activityPrice.clientType.code].quantity, activityPrice.cost);
            this.booking.clientTypes[activityPrice.clientType.code].profit = this.rounded(this.booking.clientTypes[activityPrice.clientType.code].price - this.booking.clientTypes[activityPrice.clientType.code].priceCost);
            this.booking.clientTypes[activityPrice.clientType.code].clientType = activityPrice.clientType.title;
            totalPrice += this.booking.clientTypes[activityPrice.clientType.code].price;
            this.totalPriceCost += this.booking.clientTypes[activityPrice.clientType.code].quantity * activityPrice.cost;
            this.totalPVD += this.booking.clientTypes[activityPrice.clientType.code].pvd;
          }
        })
      }
    }
    setTimeout(() => {
      this.formattedClients = [];
      Object.keys(this.booking.clientTypes).forEach(key => {
        this.formattedClients.push(this.booking.clientTypes[key]);
      });
    }, 0);

    this.totalPartnerCommission = totalPrice - this.totalPVD;

    return totalPrice.toFixed();
  }

  calculatePVD(price: any, quantity: any, cost: any) {
    if (this.pricing) {

      switch (this.pricing.type) {
        case "NETOS": return (quantity * cost) / (1 - (this.pricing.markup / 100));
        case "REPARTO": return ((quantity * cost) + ((this.rounded((quantity * price)) - (quantity * cost)) * ((100 - this.pricing.percentage) / 100)));
        default: return (quantity * price) - ((quantity * price) * (this.pricing.percentage / 100));
      }
    } else {
      return 0
    }
  }

  rounded(price: any) {
    if (this.pricing.markup) {
      switch (this.pricing.roundedPrice.toLowerCase()) {
        case "up":
          return Math.ceil(price);
        case "down":
          return Math.floor(price);
        default:
          return parseFloat(price.toFixed(2));
      }
    } else {
      return price
    }
  }

  getKeys(clientRanges: any) {
    return Object.keys(clientRanges);
  }

  getDate() {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    // Format the date into Spanish using toLocaleDateString
    const formattedDate = this.bookingDates.start.toLocaleDateString(this.translateService.currentLang, options);
    if (this.booking.availableSchedule) {
      return [formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1), this.booking.availableSchedule.activitySchedule.startTime + 'h'];
    } else {
      return []
    }
  }

  preBooking() {
    if (this.configuration.hasPVP == false && this.configuration.paymentTypes.includes('netClient') && this.mainService.isAuthenticated()) {
      this.paymentMethod = 'netClient';
      this.isLoading = true;
    }

    if ((!this.bookingForm.valid || this.bookingForm.get('conditions')?.value == false) || !this.booking.availableSchedule || Object.keys(this.booking.clientTypes).length === 0) {
      if (!this.booking.availableSchedule) {
        this.incompleteAlert = 'Por favor, elije un horario.'
      } else if (Object.keys(this.booking.clientTypes).length === 0) {
        this.incompleteAlert = 'Por favor, selecciona número de personas'
      } else if (!this.bookingForm.valid || this.bookingForm.get('conditions')?.value == false) {
        this.incompleteAlert = 'Por favor, rellena el formulario.'
      }
      setTimeout(() => {
        this.incompleteAlert = false;
      }, 5000);
      return;
    } else {
      this.isPrebookingRequested = true;
      let paxDetails: any = null;
      let paxDetailsExternal: any = null;
      let participantInfoByItem: Record<string, any> = {};

      if (this.connector != 'hub2b') {
        const paxFormArray = this.bookingForm.get('pax') as FormArray;

        const onceKeys = Object.keys(this.paxRules).filter(
          key => this.paxRules[key]?.scope ? this.paxRules[key]?.scope : this.paxRules[key] === 'ONCE'
        );

        const allKeys = Object.keys(this.paxRules).filter(
          key => this.paxRules[key]?.scope ? this.paxRules[key]?.scope : this.paxRules[key] === 'ALL'
        );

        // ✅ paxDetailsExternal (ONCE)
        paxDetailsExternal = this.paxFormArray
          ? paxFormArray.controls.map(pax => {
            const value = pax.value;
            if (!this.paxRules) return value;

            const filtered: any = {};
            onceKeys.forEach(key => {
              if (value.hasOwnProperty(key)) {
                filtered[key] = value[key];
              }
            });
            return filtered;
          })
          : [];

        if (paxFormArray) {
          paxFormArray.controls.forEach((grupo) => {
            const value = grupo.value;

            allKeys.forEach((key) => {
              if (value.hasOwnProperty(key)) {
                const itemId = this.paxRules?.[key]?.itemId;

                if (itemId) {
                  if (!participantInfoByItem[itemId]) {
                    participantInfoByItem[itemId] = {};
                  }
                  if (!participantInfoByItem[itemId][key]) {
                    participantInfoByItem[itemId][key] = [];
                  }
                  participantInfoByItem[itemId][key].push(value[key]);
                }
              }
            });
          });
        }

        paxDetails = this.bookingForm.get('pax')
          ? (this.bookingForm.get('pax') as FormArray).controls.map(pax => {
            const paxValue = pax.value;

            if (this.external_channel === 'globick_pull' && this.booking.pickup && this.booking.pickup.id) {
              paxValue.selectedPickLocation = this.booking.pickup.id;
            }

            return paxValue;
          })
          : [];
      }

      // Save client ubication in data
      this.bookingForm.get('ubication')?.value ? this.booking.clientLocation = this.bookingForm.get('ubication')?.value : '';

      let data: any = {
        checkIn: new Date(this.bookingDates.start.getTime() - (this.bookingDates.start.getTimezoneOffset() * 60000)),
        checkOut: new Date(this.bookingDates.end.getTime() - (this.bookingDates.end.getTimezoneOffset() * 60000)),
        name: this.bookingForm.get('name')?.value,
        email: this.bookingForm.get('email')?.value,
        phone: this.bookingForm.get('countryCode')?.value + this.bookingForm.get('phone')?.value,
        // phone: this.bookingForm.get('phone')?.value,
        observations: this.bookingForm.get('observations')?.value,
        promoCode: this.bookingForm.get('promoCode')?.value ? this.bookingForm.get('promoCode')?.value : '',
        totalPrice: (this.configuration.hasPVP !== false || !this.mainService.isAuthenticated()) ? this.getTotalPrice().toString() : this.totalPVD.toFixed(2).toString(),
        totalPriceCost: this.totalPriceCost.toFixed(2),
        totalPVD: this.totalPVD.toFixed(2),
        hasPVP: (this.configuration.hasPVP !== false || !this.mainService.isAuthenticated()) ? true : false,
        paymentMethod: this.paymentMethod ? this.paymentMethod : 'creditCard',
        data: [this.booking],
        hasAcceptance: true,
        status: 'preBooked',
        activity: this.channelactivitycode,
        externalLocator: null,
        language: this.lang ? this.lang : 'es',
        priceType: this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.priceType,
        paxDetails,
        paxDetailsExternal,
        paxDetailsParticipantsExternal: participantInfoByItem
      }

      // if (this.connector != 'hub2b') {
      //   data['paxDetails'] = paxDetails
      //   data['paxDetailsExternal'] = paxDetailsExternal,
      //   paxDetailsParticipantsExternal: participantInfoByItem
      // }
      this.loadPrebook = true
      this.errorPrebook = false

      // Seller
      if (this.seller) {
        data['seller'] = this.seller;
        if (this.api_url.split('.')[1] == this.external_channel) {
          this.mainService.postConnection(this.connector, this.external_channel, 'activity_prebooking', data).subscribe((activityBooking: any) => {
            this.showPaymentMethodForm = true;
            this.bookingId = activityBooking.response.id;
            if (this.paymentMethod != 'cash' && this.paymentMethod != 'credit' && this.paymentMethod != 'netClient' && !this.isOnRequest) {
              this.submitForm(activityBooking.response.id)
            } else if (this.paymentMethod == 'credit' || this.paymentMethod == 'netClient') {
              this.cashBooking()
            }
            if (this.isOnRequest) {
              this.redirectOnRequestThankYou()
            }
            this.loadPrebook = false;
          }, (error: any) => {
            this.loadPrebook = false;
            this.errorPrebook = true;
            console.log(error);
          })
        } else {
          data['isWidget'] = true;
          data['channelKey'] = this.external_channel;
          data['externalId'] = this.channelactivitycode;
          data['cartId'] = this.booking.cartId;
          data['externalLanguage'] = this.booking.externalLanguage ? this.booking.externalLanguage : 'es';

          this.mainService.postConnection(this.connector, this.external_channel, 'activity_prebooking', data).subscribe((activityBooking: any) => {
            data.activity = this.productid;
            if (this.external_channel == 'globick_pull') {
              data.externalConnectorLocator = activityBooking.response.id;
            } else if (this.external_channel == 'lowcosttours_pull') {
              data.externalSupplierLocator = activityBooking.response.id;
              let pickup = activityBooking.response.pickup
              this.booking.pickup = {
                'startTime': pickup.time,
                'title': pickup.point,
                'description': pickup.point_description,
                'address': pickup.point_description,
                'latitude': pickup.point_latitude,
                'longitude': pickup.point_longitude,
                'maps': this.returnMapsCoordenates({ pickup: { latitude: pickup.point_latitude, longitude: pickup.point_longitude } }),
                'hasPickup': true
              };
            } else if (this.connector != 'hub2b') {
              data.externalSupplierLocator = activityBooking.response.id;
            } else {
              data.externalLocator = activityBooking.response.id;
            }
            this.loadPrebook = false;
            this.mainService.post(this.api_url, 'activity_integration_prebooking', data).subscribe((activityIntegrationBooking: any) => {
              this.showPaymentMethodForm = true;
              this.bookingId = activityIntegrationBooking.response.id;
              if (this.paymentMethod != 'cash' && this.paymentMethod != 'credit' && this.paymentMethod != 'netClient' && !this.isOnRequest) {
                this.submitForm(activityIntegrationBooking.response.id)
              } else if (this.paymentMethod == 'credit' || this.paymentMethod == 'netClient') {
                this.cashBooking()
              }
              if (this.isOnRequest) {
                this.redirectOnRequestThankYou()
              }
            })
          }, (error: any) => {
            this.errorPrebook = true;
            this.loadPrebook = false;
            console.log(error);
          })
        }
      } else {
        if (this.api_url.split('.')[1] == this.external_channel) {
          this.mainService.postConnection(this.connector, this.external_channel, 'activity_prebooking', data).subscribe((activityBooking: any) => {
            this.showPaymentMethodForm = true;
            this.bookingId = activityBooking.response.id;
            if (this.paymentMethod != 'cash' && this.paymentMethod != 'credit' && this.paymentMethod != 'netClient' && !this.isOnRequest) {
              this.submitForm(activityBooking.response.id)
            } else if (this.paymentMethod == 'credit' || this.paymentMethod == 'netClient') {
              this.cashBooking()
            }
            if (this.isOnRequest) {
              this.redirectOnRequestThankYou()
            }
            this.loadPrebook = false;
          }, (error: any) => {
            this.errorPrebook = true;
            this.loadPrebook = false;
            console.log(error);
          })
        } else {
          data['isWidget'] = true;
          data['channelKey'] = this.external_channel;
          data['externalId'] = this.channelactivitycode;
          data['cartId'] = this.booking.cartId;
          data['externalLanguage'] = this.booking.externalLanguage ? this.booking.externalLanguage : 'es';
          this.mainService.postConnection(this.connector, this.external_channel, 'activity_prebooking', data).subscribe((activityBooking: any) => {
            data.activity = this.productid;
            if (this.external_channel == 'globick_pull') {
              data.externalConnectorLocator = activityBooking.response.id;
            } else if (this.connector != 'hub2b') {
              data.externalSupplierLocator = activityBooking.response.id;
            } else {
              data.externalLocator = activityBooking.response.id;
            }
            this.loadPrebook = false;
            this.mainService.post(this.api_url, 'activity_integration_prebooking', data).subscribe((activityIntegrationBooking: any) => {
              this.showPaymentMethodForm = true;
              this.bookingId = activityIntegrationBooking.response.id;
              if (this.paymentMethod != 'cash' && this.paymentMethod != 'credit' && this.paymentMethod != 'netClient' && !this.isOnRequest) {
                this.submitForm(activityIntegrationBooking.response.id)
              } else if (this.paymentMethod == 'credit' || this.paymentMethod == 'netClient') {
                this.cashBooking()
              }
              if (this.isOnRequest) {
                this.redirectOnRequestThankYou()
              }
            })
          }, (error: any) => {
            this.errorPrebook = true;
            this.loadPrebook = false;
            console.log(error);
          })
        }
      }
    }
  }

  cashBooking() {
    this.mainService.post(this.api_url, 'activity_booking', { bookingId: this.bookingId, status: 'booked' }).subscribe(resp => {
      if (resp) {
        window.location.href = window.location.href.split('?')[0] + '/thank-you/' + this.bookingId
      }
    })
  }

  checkSellerCode(sellerCode: string) {
    if (this.api_url.split('.')[1] == this.external_channel) {
      this.mainService.getByParameter(this.api_url, 'code', sellerCode, 'sellers', 'es').subscribe(resp => {
        if (resp['hydra:member'].length == 1 && resp['hydra:member'][0].id == this.seller) {
          // If the seller code actually correlates to the seller the widget is expecting
          this.isValidSeller = true
        } else {
          this.isValidSeller = false
          this.showInvalidSellerError = true;
        }
      })
    } else {
      this.mainService.getConnectionEndpoint(this.external_channel, 'sellers?code=' + sellerCode, 'es').subscribe(resp => {
        if (resp['hydra:member'].length == 1 && resp['hydra:member'][0].id == this.seller) {
          // If the seller code actually correlates to the seller the widget is expecting
          this.isValidSeller = true
        } else {
          this.isValidSeller = false
          this.showInvalidSellerError = true;
        }
      })
    }
  }

  checkForm() {
    this.bookingForm.markAllAsTouched();
    return !this.bookingForm.valid
  }

  // Fetches a payment intent and captures the client secret
  async submitForm(bookingId: number) {
    if (!this.isOnRequest) {
      const response = await fetch(this.api_url + '/initialize_checkout/' + bookingId, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          "merchantAmount": (parseFloat(this.getTotalPrice()) * 100).toString(),
          "merchantUrl": this.api_url + "/activity_booking",
          "order": bookingId.toString(),
          // "DS_MERCHANT_PAYMETHODS": 'creditCard',
          "merchantUrlKo": this.error_url,
          "merchantUrlOk": this.success_url + bookingId
        })
      });

      const checkout = await response.json();

      if (checkout.type == 'stripe') {
        let clientSecret = checkout.clientSecret;
        this.elements = this.stripe.elements({ clientSecret });

        const paymentElementOptions = {
          layout: "tabs",
        };

        // Ensure we are mounting inside the Shadow DOM

        this.shadowRoot = this.elementRef.nativeElement.shadowRoot;
        // this.shadowRoot = document.querySelector('payment-container')?.shadowRoot;
        if (!this.shadowRoot) {
          console.error("Shadow root not found!");
        }

        const paymentContainer = document.querySelector("#payment-element");
        const paymentContainerParent = document.querySelector("#payment-element-parent");
        const wc = document.querySelector("product-page-widget");
        const paymentExternalContainer = wc?.shadowRoot?.querySelector("#payment-external-element");
        const paymentExternalContainerParent = wc?.shadowRoot?.querySelector("#payment-external-element-parent");

        if (paymentContainer) {
          paymentContainerParent?.classList.add('show');
          const paymentElement = this.elements.create("payment", paymentElementOptions);
          paymentElement.mount(paymentContainer)
        } else if (paymentExternalContainer) {
          paymentExternalContainerParent?.classList.add('show');
          const paymentExternalElement = this.elements.create("payment", paymentElementOptions);
          paymentExternalElement.mount(paymentExternalContainer)
        } else {
          console.error("Payment element container not found inside Shadow DOM!");
          return;
        }
        this.showPaymentForm = true; location.href.split('?')[0]
      } else {
        var form = document.createElement("form");
        // form.target = "_self";
        form.method = "POST";
        form.action = checkout.redsysUrl;
        var params: any = {
          "Ds_SignatureVersion": "HMAC_SHA256_V1",
          "Ds_MerchantParameters": checkout.merchantParameters,
          "Ds_Signature": checkout.signature
        };
        for (var i in params) {
          if (params.hasOwnProperty(i)) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = i;
            input.value = params[i];
            form.appendChild(input);
          }
        }

        document.body.appendChild(form);

        form.submit();
      }
    }
  }

  async handleSubmit(e: any) {
    e.preventDefault();
    this.setLoading(true);

    let elements = this.elements;

    const { error } = await this.stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.href.split('?')[0] + '/thank-you/' + this.bookingId,
      },
    })

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
      this.showMessage(error.message);
    } else {
      this.showMessage("An unexpected error occurred.");
    }

    this.setLoading(false);

  }

  // ------- UI helpers -------

  public showMessage(messageText: any) {
    const messageContainer = document.querySelector("#payment-message");

    messageContainer!.classList.remove("hidden");
    messageContainer!.textContent = messageText;

    setTimeout(function () {
      messageContainer!.classList.add("hidden");
      messageContainer!.textContent = "";
    }, 4000);
  }

  // Show a spinner on payment submission
  setLoading(isLoading: any) {
    if (isLoading) {
      // Disable the button and show a spinner
      (this.shadowRoot.querySelector("#submit")! as HTMLButtonElement).disabled = true;
      this.shadowRoot.querySelector("#spinner")!.classList.remove("hidden");
      this.shadowRoot.querySelector("#button-text")!.classList.add("hidden");
    } else {
      (this.shadowRoot.querySelector("#submit")! as HTMLButtonElement).disabled = false;
      this.shadowRoot.querySelector("#spinner")!.classList.add("hidden");
      this.shadowRoot.querySelector("#button-text")!.classList.remove("hidden");
    }
  }

  async getClosestPickupSchedule(pickupSchedules: any, latitude?: any, longitude?: any) {
    if (true) {
      // this.getUserLocation()
      //   .then((position: GeolocationPosition) => {
      //     const userLat = position.coords.latitude;
      if (latitude && longitude) {
        localStorage.setItem('userLat', latitude.toString());
        //     const userLon = position.coords.longitude;
        localStorage.setItem('userLon', longitude.toString());
        //Si hay coordenadas, añadimos el pickup mas cercano a la ubicación

        if (!["musement_pull", "lowcosttours_pull"].includes(this.external_channel)) {
          this.closestPickupSchedule = await this.findClosestPickupSchedule(pickupSchedules, latitude, longitude);
        } else {
          let pickupResponse = this.findPickupCandidates(pickupSchedules, latitude, longitude, { ignoreRadius: true })
          this.pickupScheduleInRadious = pickupResponse.candidates
          this.closestPickupSchedule = pickupResponse.closest
          // console.log(this.pickupScheduleInRadious)
        }

      } else {
        //Si no hay coordenadas, añadimos el primer pickup de tipo isMeetingPoint
        this.closestPickupSchedule = pickupSchedules.find((pickupSchedule: any) => pickupSchedule.pickup?.isMeetingPoint === true);
      }

      if (this.closestPickupSchedule) {
        if (["musement_pull", "lowcosttours_pull"].includes(this.external_channel)) {
          this.bookingForm.get('pickupSchedule')?.setValue(this.closestPickupSchedule['code']);
          this.booking.pickup = this.closestPickupSchedule
          this.booking.pickup['startTime'] = this.closestPickupSchedule['startTime']
          this.booking.pickup['maps'] = this.returnMapsCoordenates(this.closestPickupSchedule)
        } else {
          this.bookingForm.get('pickupSchedule')?.setValue(this.closestPickupSchedule['@id']);
          this.booking.pickup = { 'startTime': this.closestPickupSchedule.startTime, 'title': this.closestPickupSchedule.pickup.title, 'address': this.closestPickupSchedule.pickup.address, 'maps': this.returnMapsCoordenates(this.closestPickupSchedule), 'description': this.closestPickupSchedule.pickup.description, 'imageUrl': this.closestPickupSchedule.pickup.imageUrl, 'hasPickup': this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.hasPickup };
          if (this.closestPickupSchedule.pickup.id) {
            this.booking.pickup['id'] = this.closestPickupSchedule.pickup.id
          }
        }
      }
      // })
      // .catch((err) => {
      //   this.error = 'Unable to retrieve your location: ' + err.message;
      // });
    } else {

      if (!this.closestPickupSchedule) {
        if (this.external_channel != "musement_pull") {
          this.closestPickupSchedule = await this.findClosestPickupSchedule(pickupSchedules, localStorage.getItem('userLat'), localStorage.getItem('userLon'));
        } else {
          let pickupResponse = this.findPickupCandidates(pickupSchedules, localStorage.getItem('userLat'), localStorage.getItem('userLon'), { ignoreRadius: true })
          this.pickupScheduleInRadious = pickupResponse.candidates
          this.closestPickupSchedule = pickupResponse.closest
          // console.log(this.pickupScheduleInRadious)
        }
      } else {
        if (this.external_channel != "musement_pull") {
          this.bookingForm.get('pickupSchedule')?.setValue(this.closestPickupSchedule['code']);
          this.booking.pickup = this.closestPickupSchedule['pickup']
          this.booking.pickup['startTime'] = this.closestPickupSchedule['startTime']
          this.booking.pickup['maps'] = this.returnMapsCoordenates(this.closestPickupSchedule)
        } else {
          this.bookingForm.get('pickupSchedule')?.setValue(this.closestPickupSchedule.pickup.id);
          this.booking.pickup = { 'startTime': this.closestPickupSchedule.startTime, 'title': this.closestPickupSchedule.pickup.title, 'address': this.closestPickupSchedule.pickup.address, 'maps': this.returnMapsCoordenates(this.closestPickupSchedule), 'description': this.closestPickupSchedule.pickup.description, 'imageUrl': this.closestPickupSchedule.pickup.imageUrl, 'hasPickup': this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.hasPickup };
          if (this.closestPickupSchedule.pickup.id) {
            this.booking.pickup['id'] = this.closestPickupSchedule.pickup.id
          }
        }
      }
    }
  }

  getUserLocation(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      } else {
        reject('Geolocation is not supported by this browser.');
      }
    });
  }

  // Convert degrees to radians
  private deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  // Calculate the distance between two lat/lon points using the Haversine formula
  private getDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in kilometers
  }

  // Get driving distance (preferred) via Google DistanceMatrix API. Falls back to Haversine if unavailable.
  private getDistanceMatrix(lat1: number | string, lon1: number | string, lat2: number | string, lon2: number | string): Promise<number> {
    return new Promise<number>((resolve) => {
      // try {
      //   const origin = { lat: parseFloat(String(lat1)), lng: parseFloat(String(lon1)) };
      //   const destination = { lat: parseFloat(String(lat2)), lng: parseFloat(String(lon2)) };

      //   if (!isFinite(origin.lat) || !isFinite(origin.lng) || !isFinite(destination.lat) || !isFinite(destination.lng)) {
      //     // invalid coords -> fallback
      //     resolve(this.getDistance(Number(origin.lat) || 0, Number(origin.lng) || 0, Number(destination.lat) || 0, Number(destination.lng) || 0));
      //     return;
      //   }

      //   const service = new google.maps.DistanceMatrixService();
      //   service.getDistanceMatrix(
      //     {
      //       origins: [origin],
      //       destinations: [destination],
      //       travelMode: google.maps.TravelMode.WALKING,
      //     },
      //     (response: any, status: any) => {
      //       try {
      //         if (status === 'OK' && response?.rows?.[0]?.elements?.[0]) {
      //           const element = response.rows[0].elements[0];
      //           if (element.status === 'OK' && element.distance && typeof element.distance.value === 'number') {
      //             // distance.value is meters
      //             this.pickupDistanceTime = element.duration.text
      //             resolve(element.distance.value / 1000);
      //             return;
      //           }
      //         }
      //       } catch (e) {
      //         // ignore and fallback
      //       }
      //       // fallback to Haversine
      //       resolve(this.getDistance(origin.lat, origin.lng, destination.lat, destination.lng));
      //     }
      //   );
      // } catch (e) {
      // on any error, fallback
      resolve(this.getDistance(Number(lat1) || 0, Number(lon1) || 0, Number(lat2) || 0, Number(lon2) || 0));
      // }
    });
  }

  // Find the closest zone to the user's location
  async findClosestPickupSchedule(pickupSchedules: any, userLat: any, userLon: any) {
    let closestPickupSchedule: any = null;
    this.closestDistance = Infinity;

    // Forma antígua - cálculo de dirección en linea recta
    pickupSchedules.forEach((pickupSchedule: any) => {
      const distance = this.getDistance(parseFloat(userLat), parseFloat(userLon), pickupSchedule.pickup.latitude, pickupSchedule.pickup.longitude);
      if (distance < this.closestDistance) {
        this.closestDistance = distance;
        closestPickupSchedule = pickupSchedule;
      } else if (this.closestDistance == distance) {
        closestPickupSchedule = pickupSchedule
      }
    });

    // Forma mas moderna pero cara - cálculo distancia real por caminos
    // const service = new google.maps.DistanceMatrixService();
    // const distancePromises = pickupSchedules.map((pickupSchedule: any) => {
    //   const origin = { lat: parseFloat(userLat), lng: parseFloat(userLon) };
    //   const destination = {
    //     lat: parseFloat(pickupSchedule.pickup.latitude),
    //     lng: parseFloat(pickupSchedule.pickup.longitude)
    //   };

    //   return new Promise<void>((resolve, reject) => {
    //     service.getDistanceMatrix(
    //       {
    //         origins: [origin],
    //         destinations: [destination],
    //         travelMode: google.maps.TravelMode.WALKING,
    //       },
    //       (response: any, status: any) => {
    //         if (status === "OK") {
    //           if (!response.rows[0].elements[0].distance) {
    //             resolve();
    //             return;
    //           }
    //           const distance = response.rows[0].elements[0].distance.value / 1000; //pasar a km
    //           const duration = response.rows[0].elements[0].duration.text;
    //           if (distance < this.closestDistance) {
    //             this.closestDistance = distance;
    //             this.pickupDistanceTime = duration;
    //             closestPickupSchedule = pickupSchedule;
    //           } else if (distance === this.closestDistance) {
    //             this.pickupDistanceTime = duration;
    //             closestPickupSchedule = pickupSchedule;
    //           }
    //           resolve();
    //         } else {
    //           reject(status);
    //         }
    //       }
    //     );
    //   });
    // });
    // await Promise.all(distancePromises);

    return closestPickupSchedule;
  }

  async updatePickupSelected(pickup: any) {
    this.closestPickupSchedule = pickup;

    if (!this.closestPickupSchedule) return;

    if (["musement_pull", "lowcosttours_pull"].includes(this.external_channel)) {
      const distance = await this.getDistanceMatrix(parseFloat(this.selectedLatitude), parseFloat(this.selectedLongitude), this.closestPickupSchedule.latitude, this.closestPickupSchedule.longitude);
      this.closestDistance = distance;
      this.bookingForm.get('pickupSchedule')?.setValue(this.closestPickupSchedule['code']);
      this.booking.pickup = this.closestPickupSchedule;
      this.booking.pickup['startTime'] = this.closestPickupSchedule['startTime'];
      this.booking.pickup['maps'] = this.returnMapsCoordenates(this.closestPickupSchedule);
    } else {
      const destLat = this.closestPickupSchedule?.pickup?.latitude ?? this.closestPickupSchedule.latitude;
      const destLon = this.closestPickupSchedule?.pickup?.longitude ?? this.closestPickupSchedule.longitude;
      const distance = await this.getDistanceMatrix(parseFloat(this.selectedLatitude), parseFloat(this.selectedLongitude), destLat, destLon);
      this.closestDistance = distance;
      this.bookingForm.get('pickupSchedule')?.setValue(this.closestPickupSchedule['@id']);
      this.booking.pickup = { 'startTime': this.closestPickupSchedule.startTime, 'title': this.closestPickupSchedule.pickup?.title ?? '', 'address': this.closestPickupSchedule.pickup?.address ?? '', 'maps': this.returnMapsCoordenates(this.closestPickupSchedule), 'description': this.closestPickupSchedule.pickup?.description ?? '', 'imageUrl': this.closestPickupSchedule.pickup?.imageUrl ?? '', 'hasPickup': this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.hasPickup };
      if (this.closestPickupSchedule.pickup?.id) {
        this.booking.pickup['id'] = this.closestPickupSchedule.pickup.id;
      }
    }
  }

  findPickupCandidates(
    pickupSchedules: any = [],
    userLat: any,
    userLon: any,
    opts: { radiusKm?: number; limit?: number; ignoreRadius?: boolean } = {}
  ) {
    const { radiusKm = 2, limit, ignoreRadius = false } = opts;

    const lat = parseFloat(String(userLat));
    const lon = parseFloat(String(userLon));

    const withDist = pickupSchedules
      .map((ps: any) => {
        const lat2 = parseFloat(String(ps?.pickup?.latitude));
        const lon2 = parseFloat(String(ps?.pickup?.longitude));
        const dKm = this.getDistance(lat, lon, lat2, lon2);
        return Number.isFinite(dKm) ? { item: ps, _distanceKm: dKm } : null;
      })
      .filter((x: any): x is { item: any; _distanceKm: number } => !!x)
      .sort((a: any, b: any) => a._distanceKm - b._distanceKm || String(a.item?.pickup?.id).localeCompare(String(b.item?.pickup?.id)));

    const within = withDist.filter((x: any) => x._distanceKm <= radiusKm);
    // If ignoreRadius is true, do not prefer the within-radius set — search among all by distance
    const pool = ignoreRadius ? withDist : (within.length ? within : withDist);
    const effectiveLimit = limit ?? pool.length;
    const top = pool.slice(0, effectiveLimit);

    const closestWithinRadius = !ignoreRadius && !!top[0] && top[0]._distanceKm <= radiusKm;
    const closestDistanceKm = top[0]?._distanceKm ?? null;



    return {
      closest: top[0]?.item ?? null,
      candidates: top.map((x: any) => x.item),
      closestWithinRadius,
      closestDistanceKm,
    };
  }

  sendhideCtaData() {
    this.sentData.emit(true);
  }

  orderSchedules(schedules: any) {
    // Orders schedules by startTime ascendingly
    if (schedules) {
      // console.log(schedules.sort((a: any, b: any) => {
      //   const timeA = a.activitySchedule.startTime;
      //   const timeB = b.activitySchedule.startTime;

      //   if (timeA < timeB) return -1;
      //   if (timeA > timeB) return 1;
      //   return 0;
      // }));
      return schedules.sort((a: any, b: any) => {
        const timeA = a.activitySchedule.startTime;
        const timeB = b.activitySchedule.startTime;

        if (timeA < timeB) return -1;
        if (timeA > timeB) return 1;
        return 0;
      });
    } else {
      return
    }
  }

  getLeftPax(modality: any, selectedQuantity: any, clientType?: any) {
    // selectedQuantity: cantidad seleccionada de ese tipo de cliente
    // maxSelection: máxima longitud del select
    // totalClientTypesSelected: Contador total de todos los tipos de clientes seleccionados
    this.totalClientTypesSelected = 0;
    Object.keys(this.booking.clientTypes).forEach((clientTypeKey: any) => {
      const clientType = this.booking.clientTypes[clientTypeKey]
      this.totalClientTypesSelected += parseInt(clientType.quantity)
    })
    let maxSelection = 0;
    let minSelection = 0;
    minSelection = parseInt(modality.minPax ? modality.minPax : (clientType.minPax ? clientType.minPax : 0))

    if (selectedQuantity) {
      maxSelection = (parseInt(modality.maxPax ? modality.maxPax : (clientType.maxPax > 30 ? 30 : clientType.maxPax)) - this.totalClientTypesSelected) + parseInt(selectedQuantity)
    } else {
      maxSelection = (parseInt(modality.maxPax ? modality.maxPax : (clientType.maxPax > 30 ? 30 : clientType.maxPax)) - this.totalClientTypesSelected)
    }
    // return Array.from({ length: maxSelection + 1 }, (_, i) => i);
    const result = Array.from(
      new Set([0, ...Array.from({ length: maxSelection - minSelection + 1 }, (_, i) => i + minSelection)])
    );

    return result
  }

  cleanUbicationValue() {
    this.bookingForm.get('ubication')?.setValue('');
  }

  getClosestZone() {
    return;
    this.getUserLocation()
      .then((position: GeolocationPosition) => {
        const userLat = position.coords.latitude;
        localStorage.setItem('userLat', userLat.toString());
        const userLon = position.coords.longitude;
        localStorage.setItem('userLon', userLon.toString());

        const apiKey = 'AIzaSyDVebyjsQ7ANfVLQEh9IrGosdH-8H4tzFs'
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${userLat},${userLon}&key=${apiKey}`

        // Usando fetch para hacer la solicitud
        fetch(url)
          .then(response => response.json())
          .then(data => {
            if (data.status === "OK") {
              const city = data.results[0].address_components.find((component: any) =>
                component.types.includes("locality")
              );
              const country = data.results[0].address_components.find((component: any) =>
                component.types.includes("administrative_area_level_1")
              );
              if (city) {
                this.bookingForm.get('ubication')?.setValue(city.long_name);
              } else if (country) {
                this.bookingForm.get('ubication')?.setValue(country.long_name);
              } else {
                this.bookingForm.get('ubication')?.setValue('My location in Mallorca');
              }
            } else {
              console.error("Error con la API de Google Geocoding: ", data.status);
            }
          })
          .catch(error => console.error("Error en la solicitud: ", error));
      })
      .catch((err) => {
        this.error = 'Unable to retrieve your location: ' + err.message;
      });
  }

  replacePForSpan(text: string): string {
    return text ? text.replace(/<p/g, '<span class="text"').replace(/<\/p/g, '</span') : '';
  }

  stripHTML(htmlString: string) {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;
    return tempElement.innerText;
  }


  showMoreText() {
    this.moreText = true;
  }

  getLowestPriceFromModality(modality: any) {
    let lowestPrice = Infinity;
    modality.forEach((availability: any) => {
      if (availability.activitySchedule.activitySeason.activityFee.modality.priceType == "person") {
        if (availability.activitySchedule.activityPrices[0].price < lowestPrice) {
          lowestPrice = availability.activitySchedule.activityPrices[0].price
        }
      }
      if (availability.activitySchedule.activitySeason.activityFee.modality.priceType != "person") {
        availability.activitySchedule.activityPrices.forEach((price: any) => {
          if (price.price < lowestPrice) {
            lowestPrice = price.price
          }
        });
      }
    });

    return lowestPrice
  }

  getSlotsLeft(modality: any) {
    return modality.quota - modality.totalBookings
  }

  formatedDate(dateString: any) {
    const auxDate = new Date(dateString);
    const currentLang = this.translateService.currentLang || 'en';
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      timeZone: 'Europe/Madrid'
    };
    const locale = currentLang === 'es' ? 'es-ES' : currentLang === 'de' ? 'de-DE' : 'en-US';
    let formattedDate = auxDate.toLocaleDateString(locale, options as any);
    const exceptions = ["de", "del", "la", "y", "a"];
    formattedDate = formattedDate
      .split(" ")
      .map(word => exceptions.includes(word.toLowerCase()) ? word : word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return formattedDate;
  }

  openMap(maps: any) {
    window.open(maps, '_blank');
  }

  // In local environment working rarete
  isNextStep(index?: number) {
    switch (this.currentStep) {
      case 0:
        if (!this.pickupScheduleInRadious && !this.closestPickupSchedule) {
          return true
        } else {
          return false
        }
      case 1:
        if (!this.bookingDates) {
          return true
        } else {
          return false
        }
      case 2:
        if (this.selectedModality) {
          return false;
        } else {
          return true;
        }
        if (!this.resumeModality || ((Object.keys(this.booking.clientTypes).length == 0) || this.booking.clientTypes[Object.keys(this.booking.clientTypes)[0]].quantity == 0) || index != this.selectedIndex) {
          return true
        } else {
          return false
        }
      case 3:
        if (this.bookingForm.get('ubication')?.value == '') {
          return true
        } else {
          return false
        }
      case 4:
        if (!this.bookingForm.valid || (this.configuration && this.configuration.paymentTypes && this.configuration.paymentTypes.includes('netClient') && this.mainService.isAuthenticated() && this.showPaymentMethodForm)) {
          return true
        } else {
          return false
        }
      default:
        return false
    }
  }

  showTooltip(event: MouseEvent) {
    this.isTooltipVisible = true;

    // Ajusta las coordenadas del tooltip dinámicamente
    this.tooltipPosition = {
      x: event.clientX - 250,
      y: event.clientY + 2
    };
  }

  hideTooltip() {
    this.isTooltipVisible = false;
  }

  async getHotelName(lat: number, lng: number) {
    const location = new google.maps.LatLng(lat, lng);

    const request = {
      location,
      radius: 5,
    };

    const service = new google.maps.places.PlacesService(document.createElement('div'));

    service.nearbySearch(request, (results: any[], status: any) => {
      if (status === google.maps.places.PlacesServiceStatus.OK && results.length > 0) {
        this.bookingForm.controls['ubication'].setValue(results[0].name)
      }
      return
    });
  }


  private getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
      {
        componentRestrictions: { country: 'ES' }
      }
    );

    google.maps.event.addListener(autocomplete, 'place_changed', () => {

      const place: any = autocomplete.getPlace();
      this.bookingForm.controls['ubication'].setValue(place.name)
      localStorage.setItem('userLoc', place.name.toString());
      let latitude = place.geometry?.location?.lat().toString();
      let longitude = place.geometry?.location?.lng().toString();

      let pickupSchedules;

      if (this.pickups) {
        pickupSchedules = this.pickups;
      } else if (this.booking.availableSchedule.activitySchedule.pickupSchedules && this.booking.availableSchedule.activitySchedule.pickupSchedules.length > 0) {
        pickupSchedules = this.booking.availableSchedule.activitySchedule.pickupSchedules;
      } else {
        pickupSchedules = this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.pickupSchedules;
        if (this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupGroupSchedules?.pickupSchedules && this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupGroupSchedules?.pickupSchedules.length > 0) {
          pickupSchedules = pickupSchedules.concat(this.booking.availableSchedule?.activitySchedule?.activitySeason?.activityFee?.modality?.pickupGroupSchedules?.pickupSchedules);
        }
      }

      this.selectedLatitude = latitude
      this.selectedLongitude = longitude
      this.getClosestPickupSchedule(pickupSchedules, latitude, longitude)
      this.refreshTick++;
    });
  }


  getCorrectModality() {
    switch (this.external_channel) {
      case "globick_pull":
        let data = {
          "start": this.bookingDates.start,
          "end": this.bookingDates.end,
          "productId": this.channelactivitycode,
          "modalityId": this.booking.availableSchedule.id,
        }
        let result = this.mainService.getConnection(this.connector, this.external_channel, 'sessions-filtered', data, this.translateService.currentLang, this.channelactivitycode).subscribe(result => {
          this.booking.availableSchedule.id = result.id
          this.booking.availableSchedule.activitySchedule.activitySeason.activityFee.modality.id = result.id
          this.actualizarExternalCodes(this.booking, result);
        });
    }
  }

  getPaxDetails() {
    this.booking['channelKey'] = this.external_channel;
    switch (this.external_channel) {
      case "globick_pull":
        this.loadingPaxDetails = true;
        const data = {
          productId: this.channelactivitycode,
          modalityId: this.booking.availableSchedule.id,
          startTime: this.booking.availableSchedule.activitySchedule.startTime
        };

        // Llamada al backend para obtener los campos
        this.mainService.getConnection(
          this.connector,
          this.external_channel,
          'paxdetails',
          this.booking,
          this.translateService.currentLang,
          this.channelactivitycode
        ).subscribe(result => {
          this.paxRules = result?.data;
          const numPax = this.getTotalPax();
          // this.pickups = result?.pickups;
          // console.log(this.pickups);


          this.clientTypeList = [];

          Object.entries(this.booking.clientTypes).forEach(([key, val]: any) => {
            const cantidad = Number(val.quantity) || 0;
            for (let i = 0; i < cantidad; i++) {
              this.clientTypeList.push(val.title as string); // o val.clientType si prefieres
            }
          });

          this.setPaxForms(this.paxRules, numPax);
        });
        break;
      case "musement_pull":
        this.loadingPaxDetails = true;
        this.mainService.getConnection(
          this.connector,
          this.external_channel,
          'paxdetails',
          this.booking,
          this.translateService.currentLang,
          this.channelactivitycode,
        ).subscribe(result => {
          this.paxRules = result?.paxFormated;
          this.booking.cartId = result?.cartId;

          if (this.booking.pickup && result?.pickup_time) {
            this.booking.pickup.startTime = result?.pickup_time
          }

          const numPax = this.getTotalPax();

          this.pickups = result?.pickups;

          this.clientTypeList = [];

          Object.entries(this.booking.clientTypes).forEach(([key, val]: any) => {
            const cantidad = Number(val.quantity) || 0;
            for (let i = 0; i < cantidad; i++) {
              this.clientTypeList.push(val.title as string); // o val.clientType si prefieres
            }
          });

          this.setPaxForms(this.paxRules, numPax);

        });
        break;
      case "lowcosttours_pull":

        break;
    }
  }


  getTotalPax(): number {
    const clientTypes = this.booking.clientTypes;
    let total = 0;

    Object.values(clientTypes).forEach((ct: any) => {
      total += Number(ct.quantity);
    });

    return total;
  }

  get paxFormArray(): FormArray {
    return this.bookingForm.get('pax') as FormArray;
  }


  syncFullNameFromFirstLastName(index: number) {
    const formArray = this.bookingForm.get('pax') as FormArray;
    const grupo = formArray.at(index);

    if (!grupo) return;

    const firstNameCtrl = grupo.get('firstname');
    const lastNameCtrl = grupo.get('lastname');
    const nameCtrl = grupo.get('name');
    const globalNameCtrl = this.bookingForm.get('name');

    const updateFullName = () => {
      const first = firstNameCtrl?.value || '';
      const last = lastNameCtrl?.value || '';
      const fullName = `${first} ${last}`.trim();

      if (nameCtrl) {
        nameCtrl.setValue(fullName, { emitEvent: false });
      }

      if (globalNameCtrl) {
        globalNameCtrl.setValue(fullName, { emitEvent: false });
      }
    };

    if (firstNameCtrl && lastNameCtrl) {
      firstNameCtrl.valueChanges.subscribe(updateFullName);
      lastNameCtrl.valueChanges.subscribe(updateFullName);
    }
  }


  syncContactPhoneToPhoneNumber(index: number) {
    const formArray = this.bookingForm.get('pax') as FormArray;
    const grupo: any = formArray.at(index);

    if (!grupo) return;

    const contactPhoneCtrl = this.bookingForm.get('phone');
    const phoneCtrl = grupo.get('phone');

    // 🔎 Buscar key que termine en 'phone_number'
    const phoneNumberKey = Object.keys(grupo.controls).find(key =>
      key.toLowerCase().endsWith('phone_number')
    ) ?? Object.keys(grupo.controls).find(key =>
      key.toLowerCase().endsWith('phonenumber')
    );

    const phoneNumberCtrl = phoneNumberKey
      ? grupo.get([phoneNumberKey])
      : null;

    if (phoneNumberCtrl && contactPhoneCtrl && phoneCtrl) {
      contactPhoneCtrl.valueChanges.subscribe((val: any) => {
        phoneNumberCtrl.setValue(this.bookingForm.get('countryCode')?.value + val, { emitEvent: false });
      });
      phoneCtrl.valueChanges.subscribe((val: any) => {
        phoneNumberCtrl.setValue(this.bookingForm.get('countryCode')?.value + val, { emitEvent: false });
      });
    }
  }

  // Helper: escoge la key de email correcta dentro del grupo
  private findEmailKey(grupo: FormGroup, extraId?: string): string | undefined {
    const keys = Object.keys(grupo.controls);
    const lc = (s: string) => s.toLowerCase();

    // 1) Match exacto: extra_customer_data.<uuid>.email
    if (extraId) {
      const exact = keys.find(k => {
        const kk = lc(k);
        return kk.startsWith(`extra_customer_data.${extraId.toLowerCase()}`) && kk.endsWith('.email');
      });
      if (exact) return exact;
    }

    // 2) Cualquier extra_customer_data.*.email
    const anyExtra = keys.find(k => {
      const kk = lc(k);
      return kk.includes('extra_customer_data') && kk.endsWith('.email');
    });
    if (anyExtra) return anyExtra;

    // 3) Fallbacks civilizados
    const addr = keys.find(k => lc(k).endsWith('email_address'));
    if (addr) return addr;

    // 4) Último recurso: el 'email' plano
    return keys.find(k => lc(k) === 'email');
  }


  // 1) Rellena el campo que termine en email_address (o email) con los cambios
  syncContactEmailToEmailAddress(index: number, extraId?: string) {
    const formArray = this.bookingForm.get('pax') as FormArray;
    const grupo = formArray.at(index) as FormGroup;

    if (!grupo) return;

    const contactEmailCtrl = this.bookingForm.get('email');
    const paxEmailCtrl = grupo.get('email');

    const emailKey = this.findEmailKey(grupo, extraId);
    const emailAddressCtrl = emailKey ? grupo.get([emailKey]) : null;

    if (emailAddressCtrl) {
      if (contactEmailCtrl) {
        contactEmailCtrl.valueChanges.subscribe((val: any) => {
          emailAddressCtrl.setValue(val ?? '', { emitEvent: false });
        });
      }
      if (paxEmailCtrl) {
        paxEmailCtrl.valueChanges.subscribe((val: any) => {
          emailAddressCtrl.setValue(val ?? '', { emitEvent: false });
        });
      }

      // Opcional: initial sync para no esperar al primer cambio
      const seed =
        (contactEmailCtrl?.value as string) ??
        (paxEmailCtrl?.value as string) ??
        '';
      emailAddressCtrl.setValue(seed, { emitEvent: false });
    }
  }


  getFormGroupControls(group: any): { key: string, control: any }[] {
    return Object.keys(group.controls).map(key => ({
      key,
      control: group.get(key)
    }));

  }

  extractFieldName(fullKey: string): string {
    const parts = fullKey.split('.');
    return parts[parts.length - 1].toLowerCase();
  }

  hasNameFieldOverride(i: number): boolean {
    if (!this.paxControlList || !this.paxControlList[i]) return false;
    const keys = this.paxControlList[i].map((c: any) => c.key);
    return keys.includes('firstname') && keys.includes('lastname');
  }

  getTitle(key: string): string {
    const f = this.paxControlList[0]?.find((x: any) => x.key === key);
    return f?.title && f.title.trim()
      ? f.title
      : key.replace(/([a-z])([A-Z])/g, '$1 $2')   // firstname -> first name
        .replace(/^./, s => s.toUpperCase());  // First name
  }

  hasPhoneNumberField(index: number): boolean {
    return this.paxControlList[index]?.some(
      (f: any) => f.key?.toLowerCase?.() === 'phone_number'
    ) ?? false;
  }

  setPaxForms(paxRules: any, cantidad: number) {
    const formArray = this.bookingForm.get('pax') as FormArray;
    formArray.clear();
    this.paxControlList = [];

    this.tieneCamposAll = Object.values(paxRules ?? {}).some((field: any) => {
      if (typeof field === 'string') {
        return field.toUpperCase() === 'ALL';
      }
      if (field && typeof field === 'object') {
        return String(field.scope ?? '').toUpperCase() === 'ALL';
      }
      return false;
    });

    if (!this.tieneCamposAll) {
      cantidad = 1;
    }

    for (let i = 0; i < cantidad; i++) {
      const controls: any = {};

      if (i == 0) {
        // Campos base (puedes eliminarlos si ya vienen del back como campos ONCE)
        controls['name'] = [null, Validators.required];
        controls['phone'] = [null, Validators.required];
        controls['email'] = [null, [Validators.required, Validators.email]];
      }

      Object.entries(paxRules).forEach(([campo, config]: any) => {
        // 🔍 Detectar si es formato viejo o nuevo
        let scope = typeof config === 'string' ? config : config.scope;
        let isFirstPax = i === 0;

        if (scope === 'ALL' || (scope === 'ONCE' && isFirstPax)) {
          if (!controls[campo]) {
            // 👉 Opcional: puedes meter validadores según el tipo
            const validators = [];

            if (typeof config === 'object') {
              if (config.inputType === 'email') validators.push(Validators.email);
              if (campo === 'email' || config.required) validators.push(Validators.required);
            } else {
              // para los casos antiguos
              validators.push(Validators.required);
            }

            controls[campo] = [null, validators];
          }
        }
      });

      const grupo = this.fb.group(controls);
      formArray.push(grupo);

      this.paxControlList.push(
        Object.keys(grupo.controls).map(key => ({
          key,
          control: grupo.get(key)!,
          title: paxRules?.[key]?.title || key || "",
          itemId: paxRules?.[key]?.itemId || null
        }))
      );
    }

    this.syncContactPhoneToPhoneNumber(0);
    (this.paxFormArray.controls || []).forEach((_, i) => {
      this.syncFullNameFromFirstLastName(i);
    });

    this.syncContactEmailToEmailAddress(0)

    // 👑 Campos generales (solo ONCE, lo puedes automatizar si quieres)
    if (cantidad > 0) {
      const primerPax = formArray.at(0);

      ['name', 'phone', 'email'].forEach(campo => {
        const val = primerPax.get(campo)?.value || '';
        this.bookingForm.get(campo)?.setValue(val);

        primerPax.get(campo)?.valueChanges.subscribe(val =>
          this.bookingForm.get(campo)?.setValue(val, { emitEvent: false }));
      });
    }
    this.loadingPaxDetails = false;
  }

  actualizarExternalCodes(objViejo: any, objNuevo: any) {
    const nuevosPrecios = objNuevo.activitySchedule.activityPrices;

    Object.entries(objViejo.clientTypes).forEach(([key, tipoCliente]: any) => {
      const match = nuevosPrecios.find((p: any) => p.clientType.code === key);

      if (match) {
        tipoCliente.externalCode = match.id;
        tipoCliente.price = match.price;
        tipoCliente.priceCost = match.cost;
      }
    });

    return objViejo;
  }

  toInt(number: any) {
    return parseInt(number);
  }

  checkForShortDistances(distance: any) {
    if (parseFloat(distance) < 2) {
      distance = distance * 1000
      return parseInt((parseFloat(distance).toFixed(2)).toString()) + 'm'
    }
    else {
      if (this.channelactivitycode == "musement_pull") {
        return (distance / 1000).toFixed(2) + ' km'
      } else {
        return (distance).toFixed(2) + ' km'
      }
    }
  }

  redondearEntero(numero: any) {
    return numero.toFixed(2);
  }

  returnMapsCoordenates(pickupSchedule: any) {
    let userLat = localStorage.getItem('userLat');
    let userLon = localStorage.getItem('userLon');

    // Safely resolve coordinates: pickup may be null or missing
    const latitude = String(pickupSchedule?.pickup?.latitude ?? pickupSchedule?.latitude ?? '');
    const longitude = String(pickupSchedule?.pickup?.longitude ?? pickupSchedule?.longitude ?? '');

    if (userLat && userLon && latitude && longitude) {
      return 'https://www.google.com/maps/dir/?api=1&origin=' + userLat + ',' + userLon + '&destination=' + latitude + ',' + longitude + '&travelmode=' + this.getTravelMode(userLat, userLon, latitude, longitude);
    } else if (latitude && longitude) {
      return 'https://maps.google.com/?q=' + latitude + ',' + longitude;
    } else {
      // Fallback: no valid coordinates available
      return 'https://maps.google.com/';
    }
  }

  getTravelMode(startLat: string, startLon: string, endLat: string, endLon: string) {
    const earthRadius = 6371; // Earth Radius in km

    const lat1 = parseFloat(startLat);
    const lon1 = parseFloat(startLon);
    const lat2 = parseFloat(endLat);
    const lon2 = parseFloat(endLon);

    // Convert degrees to radians
    const dLat = this.degreesToRadians(lat2 - lat1);
    const dLon = this.degreesToRadians(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.degreesToRadians(lat1)) * Math.cos(this.degreesToRadians(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadius * c; // Distance in km

    // Determine travel mode
    return distance > 1 ? 'driving' : 'walking';
  }

  degreesToRadians(degrees: number): number {
    return degrees * (Math.PI / 180);
  }

  validateNumber(event: any) {
    event.target.value = event.target.value.replace(/[^0-9+]/g, ''); // Elimina letras
  }

  private injectBootstrap() {
    const shadowRoot = this.elementRef.nativeElement.shadowRoot;

    const csslink = document.createElement('link');
    csslink.rel = 'stylesheet';
    csslink.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css';
    csslink.crossOrigin = 'anonymous';

    // Asegurar que los estilos solo se inyectan dentro del Shadow DOM
    shadowRoot.appendChild(csslink);

    // Inyectar Google Fonts

    if (!document.querySelector(`link[href="https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = "https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap";
      document.head.appendChild(link);
    }

    // Cargar el script de Google Maps si no está cargado
    if (!shadowRoot.querySelector('script#google-maps') && !document.querySelector('script#google-maps')) {
      const script = this.renderer.createElement('script');
      script.id = 'google-maps';
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDVebyjsQ7ANfVLQEh9IrGosdH-8H4tzFs&libraries=places,geometry';
      script.defer = true; // Asegura que el script se ejecute después de la carga completa
      this.renderer.appendChild(shadowRoot, script);
    }
  }

  onActivate(component: any) {
    // Verifica si el componente tiene un output `componentLoaded`
    if (component.componentLoaded) {
      this.isLoading = true; // Inicia cargando
      component.componentLoaded.subscribe(() => {
        this.isLoading = false; // Termina de cargar
        this.cdr.detectChanges();
      });
    } else {
      // Si el componente no emite eventos, muestra el header/footer inmediatamente
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  }

  setColors(color: string, secondaryColor: string) {
    if (color) {
      document.documentElement.style.setProperty('--primary-color', color);
      document.documentElement.style.setProperty('--mdc-circular-progress-active-indicator-color', color);
      document.documentElement.style.setProperty('--secondary-color', this.lightenColor(color, 30));
      document.documentElement.style.setProperty('--fourth-color', this.lightenColor(color, 95));
    }
    if (secondaryColor) {
      document.documentElement.style.setProperty('--terciary-color', secondaryColor);
    }
  }

  lightenColor(hex: string, percentage: number): string {
    // Asegúrate de que el hexadecimal comienza con "#"
    if (hex[0] === '#') {
      hex = hex.slice(1);
    }

    // Convertir el hexadecimal a valores RGB
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Calcular cuánto se debe aclarar cada componente RGB
    r = Math.round(r + (255 - r) * (percentage / 100));
    g = Math.round(g + (255 - g) * (percentage / 100));
    b = Math.round(b + (255 - b) * (percentage / 100));

    // Convertir de nuevo los valores RGB a hexadecimal
    const newR = r.toString(16).padStart(2, '0');
    const newG = g.toString(16).padStart(2, '0');
    const newB = b.toString(16).padStart(2, '0');

    // Devolver el color hexadecimal aclarado
    return `#${newR}${newG}${newB}`;
  }

  toggleAccordion(accordion: string) {
    const shadowRoot = document.querySelector("app-booking-widget")?.shadowRoot;
    const element = shadowRoot?.getElementById(accordion);

    if (element?.classList.contains("show")) {
      element.classList.remove("show");
      element.classList.add("hide");
      if (this.currentStep == 2 || 3) {
        this.isStepTwoCollapsed = true;
      }
    } else {
      element?.classList.remove("hide");
      element?.classList.add("show");
      if (this.currentStep == 2 || 3) {
        this.isStepTwoCollapsed = false;
      }
    }

    if (!element) {
      console.error("Elemento no encontrado:", accordion);
    }
  }

  checkWidget() {
    if (this.api_url.split('.')[1] == this.external_channel) {
      this.validSeller = true;
      this.cdr.detectChanges();
      if (this.partner.activities.includes('/activities/' + this.channelactivitycode)) {
        // If the received partner includes the activity
        this.validActivity = true;
        this.cdr.detectChanges();
      } else {
        console.warn('Received partner does not include the activity.')
      }
    } else {
      if (this.partner.activities.includes('/activities/' + this.channelactivitycode)) {
        // If the received partner includes the activity
        this.validActivity = true;
        this.cdr.detectChanges();
      } else {
        console.warn('Received partner does not include the activity.')
      }
    }
    this.validActivity = true;
    this.validSeller = true;
    this.cdr.detectChanges();
  }

  formatDateToCustomISO(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const time = `${hours}:${minutes}:${seconds}`;

    const offsetMinutes = date.getTimezoneOffset(); // Negative if ahead of UTC
    const offsetHours = String(Math.floor(Math.abs(offsetMinutes) / 60)).padStart(2, '0');
    const offsetMins = String(Math.abs(offsetMinutes) % 60).padStart(2, '0');
    const sign = offsetMinutes <= 0 ? '+' : '-';

    const timezone = `${sign}${offsetHours}:${offsetMins}`;

    return `${year}-${month}-${day}T${time}${timezone}`;
  }

  handleScheduleClick(modality: any, i: number, j: number, availableSchedule: any) {
    if (this.selectedModality && this.selectedModality.title == modality) {
      return;
    }
    if (this.checkReleaseOnSchedule(this.availableSchedules[modality][j])) return;

    if (this.external_channel === 'globick_pull') {
      let id = availableSchedule
      this.loadRealAvailability = true
      this.modHasRealAvailability = false
      this.mainService.getConnection(this.connector, this.external_channel, 'check-availability-and-rates', id, this.lang).subscribe(resp => {
        if (resp.data.sessionAvailabilityCheck) {
          this.modHasRealAvailability = true
        } else {
          this.modHasRealAvailability = false
        }
        this.loadRealAvailability = false;
      })
    }

    this.selectedModality = {
      title: modality,
      description: this.modalities[modality][j].activitySchedule.activitySeason.activityFee.modality.description,
      dynamicQuestions: this.modalities[modality][j].activitySchedule.activitySeason.activityFee.modality.dynamicQuestions,
      pickupHelpText: this.modalities[modality][j].activitySchedule.activitySeason.activityFee.modality.pickupHelpText
    };
    // console.log(this.selectedModality.dynamicQuestions);

    this.dynamicQuestionsArray.clear();
    // console.log(this.dynamicQuestionsArray);

    if (this.selectedModality.dynamicQuestions) {
      this.dynamicQuestions = [];
      // console.log(this.lang);
      this.selectedModality.dynamicQuestions.forEach((dynamicQuestion: any) => {

        if (dynamicQuestion.externalId) {
          this.dynamicQuestions.push(dynamicQuestion)
          if (dynamicQuestion.isMandatory) {
            this.dynamicQuestionsArray.push(new FormControl('', Validators.required));
          } else {
            this.dynamicQuestionsArray.push(new FormControl(''));
          }
        } else if (!dynamicQuestion.title && Object.prototype.toString.call(dynamicQuestion) === '[object String]') {
          let id = dynamicQuestion.split('/')[2];
          if (this.api_url.split('.')[1] == this.external_channel) {
            // API_URL: string, id: any, endpoint: string, language: any
            this.mainService.get(this.dynamicApiUrl, id, 'dynamic_questions', this.lang).subscribe(resp => {
              this.dynamicQuestions.push(resp)
              if (resp.isMandatory) {
                this.dynamicQuestionsArray.push(new FormControl('', Validators.required));
                console.log(this.dynamicQuestionsArray);
              } else {
                this.dynamicQuestionsArray.push(new FormControl(''));
              }
            })
          } else {
            // externalChannel: string, endpoint: string, id: string, language: any
            this.mainService.getConnection(this.connector, this.external_channel, 'dynamic_questions', id, this.lang).subscribe(resp => {
              this.dynamicQuestions.push(resp)
              if (resp.isMandatory) {
                this.dynamicQuestionsArray.push(new FormControl('', Validators.required));
              } else {
                this.dynamicQuestionsArray.push(new FormControl(''));
              }
            })
          }
        }
      })
    }

    this.resumeModality = modality;
    this.selectedIndex = i;
    this.selectedScheduleIndex = j;
    this.booking.availableSchedule = availableSchedule;

    this.formattedActivityPrices = this.getUniqueClientTypesByTitle(availableSchedule.activitySchedule.activityPrices);

    this.room.schedule = null;
    this.setHorary(availableSchedule.activitySchedule.startTime);

    this.getClosestPickupSchedule(
      (availableSchedule.activitySchedule.pickupSchedules && availableSchedule.activitySchedule.pickupSchedules.length > 0 ? availableSchedule.activitySchedule.pickupSchedules : availableSchedule.activitySchedule.activitySeason.activityFee.modality.pickupSchedules)
    );

    // Al final del loop, fuera del for
    setTimeout(() => {
      this.dynamicQuestions = this.dynamicQuestions.filter(
        (question: any, index: any, self: any) =>
          index === self.findIndex((q: any) => q.id === question.id)
      );
    }, 1000);
  }

  addTimeToISODate(isoDateString: any, addTime = "00:00", subtractHoursString = "0") {
    const baseDate = new Date(isoDateString);

    // Parse add time
    const [addHours, addMinutes] = addTime.split(':').map(Number);

    // Parse subtract hours
    const subtractHours = parseInt(subtractHoursString, 10) || 0;

    // Total delta in minutes
    const totalDeltaMinutes = (addHours * 60 + addMinutes) - (subtractHours * 60);

    const updatedDate = new Date(baseDate.getTime() + totalDeltaMinutes * 60 * 1000);
    updatedDate.setSeconds(0);
    updatedDate.setMilliseconds(0);

    // Format to ISO with timezone
    const year = updatedDate.getFullYear();
    const month = String(updatedDate.getMonth() + 1).padStart(2, '0');
    const day = String(updatedDate.getDate()).padStart(2, '0');
    const hour = String(updatedDate.getHours()).padStart(2, '0');
    const minute = String(updatedDate.getMinutes()).padStart(2, '0');
    const second = '00';

    const offsetMinutes = updatedDate.getTimezoneOffset();
    const sign = offsetMinutes <= 0 ? '+' : '-';
    const offsetHours = String(Math.floor(Math.abs(offsetMinutes) / 60)).padStart(2, '0');
    const offsetMins = String(Math.abs(offsetMinutes) % 60).padStart(2, '0');

    const timezone = `${sign}${offsetHours}:${offsetMins}`;

    return `${year}-${month}-${day}T${hour}:${minute}:${second}${timezone}`;
  }

  checkReleaseOnSchedule(activityAvailability: any) {
    // Comprueba que la hora actual es inferior a la 
    // fecha seleccionada sumada al horario de la actividad menos el release, 
    // si está fuera del release mostrar pero no permitir el click
    let now = new Date()

    const modality = activityAvailability?.activitySchedule?.activitySeason?.activityFee?.modality;
    const activity = activityAvailability?.activitySchedule?.activitySeason?.activityFee?.activity;

    // Si la modalidad es flexible, usar endTime; en caso contrario usar startTime.
    // Fallback seguro para evitar undefined.
    const scheduleTime = modality?.hasFlexibleHorary
      ? (activityAvailability?.activitySchedule?.endTime || activityAvailability?.activitySchedule?.startTime)
      : activityAvailability?.activitySchedule?.startTime;

    const releaseHour = modality?.releaseHour ? modality.releaseHour : activity?.releaseHour ? activity.releaseHour : 0;

    if (this.formatDateToCustomISO(now) < this.addTimeToISODate(activityAvailability.date, scheduleTime, releaseHour)) {
      return false
    } else {
      return true
    }
  }

  getUniqueClientTypesByTitle(prices: any[]): any[] {
    // Recibe un array de activityPrices y devuelve un nuevo array con elementos que tienen un clientType.title único
    const seenTitles = new Set<string>();

    return prices.filter(item => {
      const title = item.clientType.title + item.clientType.minAge + item.clientType.maxAge;
      if (seenTitles.has(title)) {
        return false;
      } else {
        seenTitles.add(title);
        return true;
      }
    });
  }

  redirectOnRequestThankYou() {
    // Redirigir a la thank you on request
    window.location.href = window.location.href.split('?')[0] + '/thank-you-request/' + this.bookingId;
  }

  checkDistance(distance: any) {
    return distance != Infinity;
  }

  // filterCountries(value: string): any[] {
  //   const filterValue = (value || '').toLowerCase().trim();
  //   console.log(filterValue);
  //   if (!filterValue) return [];
  //   console.log(filterValue);

  //   return this.countries
  //     .filter((c: any) =>
  //       c.name.toLowerCase().startsWith(filterValue)
  //     )
  //     .slice(0, 20); // limitar resultados visibles
  // }

  selectCountry(country: any) {
    this.bookingForm.get('countryCode')!.setValue(country.phone[0]);
    this.showCountryCodes = false;
  }

  onShadowClick(event: Event) {
    const target = event.target as HTMLElement;
    if (target.id === 'countryCode' || target.id === "countryCodeOption") {
      this.showCountryCodes = true;
      const inputEl = this.shadowRoot.getElementById('countryCode') as HTMLInputElement;
      inputEl?.focus({ preventScroll: true });
    } else {
      this.showCountryCodes = false;
    }
  }

  trackByName(country: any) {
    return country.name;
  }

  onCountryInputChange(event: any) {
    const input = event.target as HTMLInputElement;
    const value = input?.value || '';

    const filterValue = value.toLowerCase().trim();

    if (!filterValue) {
      this.countriesToShow = [];
      this.showCountryCodes = false;
      return;
    }

    this.countriesToShow = this.countries
      .filter((c: any) =>
        c.phone[0].includes(filterValue) ||
        c.name.toLowerCase().startsWith(filterValue)
      )
      .slice(0, 20);

    this.showCountryCodes = this.countriesToShow.length > 0;
  }

  goBack(step: number) {
    console.log('Volver al paso ' + step);

    switch (step) {
      case 1:
        // OK
        this.currentStep = 1;
        return
      case 3:
        // Marcar día en el calendario y marcar pax en la modalidad
        this.currentStep = 3;
        this.selectedRangeValue = this.bookingDates.start;
        this.isStepTwoCollapsed = true;
        this.changeVisibility();
        setTimeout(() => {
          this.toggleAccordion('collapseTwo');
          this.toggleAccordion('collapseOne');
        }, 500);

        // Aquí estan los pax seleccionados previamente
        // console.log(this.booking.clientTypes);

        this.cdr.detectChanges(); // fuerza un render inmediato

        this.formattedActivityPrices.forEach((formattedActivityPrice: any) => {
          Object.keys(this.booking.clientTypes).forEach((key: string) => {
            if (key === formattedActivityPrice.clientType.code) {
              const element = this.shadowRoot?.getElementById(String(key));
              if (element) {
                element.value = this.booking.clientTypes[key].quantity;
              }
            }
          });
        });
        return
    }
  }

}